/*
 * PFC standalone print product page.
 *
 *   Flat photo / art giclée print — no frame, no mount. Live canvas preview of
 *   the uploaded image on a paper card at the chosen size's aspect ratio.
 *
 *   - Variant axis = Size only (preset sizes + a Custom Size variant).
 *   - Custom Size = AREA-priced via the Custom variant's Bundle Pro ladder.
 *   - The uploaded image IS the product, so it is uploaded to S3 on ATC.
 *
 * Borrows the moulding/mount customiser's preview + bottom-sheet + cropper +
 * cart patterns, with none of the frame/mount/aperture/colour machinery.
 */
(function () {
  var root = document.querySelector('[data-pfc-print]');
  var cfg = window.PFC_PRINT;
  if (!root || !cfg || !Array.isArray(cfg.variants) || !cfg.variants.length) return;

  var UI_FONT = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';
  var PERS_FONTS = (cfg.personalisation && cfg.personalisation.fonts) || ['Playfair Display','Cormorant Garamond','EB Garamond','Lora','Cinzel','Montserrat','Poppins','Raleway','Oswald','Dancing Script','Great Vibes','Sacramento'];

  /* ---------- Element refs ---------- */
  var elPreview = root.querySelector('[data-preview]');
  var elCanvas = root.querySelector('[data-preview-canvas]');
  var elSheet = root.querySelector('[data-sheet]');
  var elSheetHandle = root.querySelector('[data-sheet-handle]');
  var elSheetSummary = root.querySelector('[data-sheet-summary]');
  var elSheetPrice = root.querySelector('[data-sheet-price]');
  var elOrientToggles = Array.from(root.querySelectorAll('[data-orientation-toggle]'));
  var elOrientBtns = Array.from(root.querySelectorAll('[data-orientation-btn]'));
  var elSizeSelect = root.querySelector('[data-size-select]');
  var elSizeTrigger = root.querySelector('[data-size-trigger]');
  var elSizeValue = root.querySelector('[data-size-value]');
  var elSizeList = root.querySelector('[data-size-list]');
  var elSizeUnitBtns = Array.from(root.querySelectorAll('[data-size-unit]'));
  var elCustom = root.querySelector('[data-custom]');
  var elCustomToggle = root.querySelector('[data-custom-toggle]');
  var elCustomW = root.querySelector('[data-custom-w]');
  var elCustomH = root.querySelector('[data-custom-h]');
  var elCustomUnitBtns = Array.from(root.querySelectorAll('[data-custom-unit]'));
  var elCustomFeedback = root.querySelector('[data-custom-feedback]');
  var elPrintsizeChip = root.querySelector('[data-printsize-chip]');
  var elPrintsizeVal = root.querySelector('[data-printsize]');
  var elPrice = root.querySelector('[data-price]');
  var elCompare = root.querySelector('[data-compare]');
  var elUpload = root.querySelector('[data-upload]');
  var elUploadTitle = root.querySelector('[data-upload-title]');
  var elFileInput = root.querySelector('[data-file-input]');
  // iOS: drop HEIC from accept so the picker hands over a full-res JPEG itself.
  if (elFileInput && window.PFCUploadNormalise) elFileInput.accept = window.PFCUploadNormalise.accept();
  var elRecrop = root.querySelector('[data-recrop-btn]');
  var elReplace = root.querySelector('[data-replace-btn]');
  var elAtc = root.querySelector('[data-atc]');
  var elAtcStatus = root.querySelector('[data-atc-status]');
  var elCropModal = root.querySelector('[data-crop-modal]');
  var elCropImg = root.querySelector('[data-crop-img]');
  var elCropCancel = root.querySelector('[data-crop-cancel]');
  var elCropConfirm = root.querySelector('[data-crop-confirm]');
  // Add-on (frame + mount) refs
  var elAddons = root.querySelector('[data-addons]');
  var elFrameToggle = root.querySelector('[data-addon-frame-toggle]');
  var elFrameLabel = elFrameToggle && (elFrameToggle.closest('.pfc-extra') || elFrameToggle.closest('label'));
  var elMountToggle = root.querySelector('[data-addon-mount-toggle]');
  var elFramePicker = root.querySelector('[data-frame-picker]');
  var elFrameGrid = root.querySelector('[data-frame-grid]');
  var elFrameDetail = root.querySelector('[data-frame-detail]');
  var elFrameUnlock = root.querySelector('[data-frame-unlock]');
  var elFrameChip = root.querySelector('[data-frame-chip]');
  var elMountChip = root.querySelector('[data-mount-chip]');
  var elBarPrice = root.querySelector('[data-bar-price]');
  var elFrameFramingWrap = root.querySelector('[data-frame-framing-wrap]');
  var elFrameFramingBtns = Array.from(root.querySelectorAll('[data-frame-framing] [data-framing]'));
  var elFramePrice = root.querySelector('[data-frame-price]');
  var elMountPicker = root.querySelector('[data-mount-picker]');
  var elMountPrice = root.querySelector('[data-mount-price]');
  var elTierBtns = Array.from(root.querySelectorAll('[data-mount-tier] [data-tier]'));
  var elMountColourWrap = root.querySelector('[data-mount-colour-wrap]');
  var elMountBorders = root.querySelector('[data-mount-borders]');
  var elMountBorderCustom = root.querySelector('[data-mount-border-custom]');
  var elAddonSize = root.querySelector('[data-addon-size]');
  var elMountColours = root.querySelector('[data-mount-colours]');
  var elMountPatternWrap = root.querySelector('[data-mount-pattern-wrap]');
  var elMountPatterns = root.querySelector('[data-mount-patterns]');
  var elMountStripeWrap = root.querySelector('[data-mount-stripe-wrap]');
  var elMountStripes = root.querySelector('[data-mount-stripes]');
  var elAddonNote = root.querySelector('[data-addon-note]');
  // Personalisation (printed text/logo on the mount)
  var elPersWrap = root.querySelector('[data-pers-wrap]');
  var elPersToggle = root.querySelector('[data-pers-toggle]');
  var elPersPanel = root.querySelector('[data-pers-panel]');
  var elPersFitNote = root.querySelector('[data-pers-fit-note]');
  var elPersPrice = root.querySelector('[data-pers-price]');
  var elPersHeading = root.querySelector('[data-pers-heading]');
  var elPersLine2 = root.querySelector('[data-pers-line2]');
  var elPersFontSelect = root.querySelector('[data-pers-font-select]');
  var elPersFontTrigger = root.querySelector('[data-pers-font-trigger]');
  var elPersFontValue = root.querySelector('[data-pers-font-value]');
  var elPersFontList = root.querySelector('[data-pers-font-list]');
  var elPersAlignBtns = Array.from(root.querySelectorAll('[data-pers-align]'));
  var elPersSizeBtns = Array.from(root.querySelectorAll('[data-pers-size]'));
  var elPersSizeGroup = root.querySelector('[data-pers-size-group]');
  var elPersSizeNote = root.querySelector('[data-pers-size-note]');
  var elPersLogoToggle = root.querySelector('[data-pers-logo-toggle]');
  var elPersLogoFields = root.querySelector('[data-pers-logo-fields]');
  var elPersLogoPosBtns = Array.from(root.querySelectorAll('[data-pers-logo-pos]'));
  var elPersLogoDrop = root.querySelector('[data-pers-logo-drop]');
  var elPersLogoThumb = root.querySelector('[data-pers-logo-thumb]');
  var elPersLogoTitle = root.querySelector('[data-pers-logo-title]');
  var elPersLogoInput = root.querySelector('[data-pers-logo-input]');

  /* ---------- State ---------- */
  // cm/inch size split (the product carries both metric A-sizes + imperial inch
  // sizes as separate variants). Inch titles contain a double-quote.
  function variantUnit(v) {
    return (v && v.title && v.title.indexOf('"') !== -1) ? 'in' : 'cm';
  }
  // Default list unit by store: US → inch, UK → cm.
  function defaultSizeUnit() {
    return (cfg.customPricing && cfg.customPricing.usd) ? 'in' : 'cm';
  }
  function initialVariant() {
    if (cfg.defaultSize) {
      var m = cfg.variants.find(function (v) { return v.title === cfg.defaultSize && !v.isCustom; });
      if (m) return m;
    }
    var byId = cfg.variants.find(function (v) { return v.id === cfg.defaultVariantId && !v.isCustom; });
    if (byId) return byId;
    var unit = defaultSizeUnit();
    var inUnit = cfg.variants.find(function (v) { return !v.isCustom && variantUnit(v) === unit; });
    if (inUnit) return inUnit;
    return cfg.variants.find(function (v) { return !v.isCustom; }) || cfg.variants[0];
  }
  function customVariant() {
    return cfg.variants.find(function (v) { return v.isCustom; }) || null;
  }

  var state = {
    variant: initialVariant(),
    orientation: (cfg.initialOrientation === 'landscape') ? 'landscape' : 'portrait',
    userImg: null,           // HTMLImageElement of cropped preview
    previewDataUrl: null,    // 900px crop — cart thumbnail + canvas preview only
    originalUrl: null,
    srcImg: null,            // HTMLImageElement of the ORIGINAL upload (uncropped)
    cropData: null,          // crop box in the original's natural pixels
    croppedAspect: null,     // the print ratio the JPEGs above were cut to
    cropStale: false,        // ratio moved on and the original is gone — must recrop
    pendingPrev: null,       // confirmed photo a not-yet-confirmed pick replaced
    cropFor: null,           // S3 url of the original the confirmed crop belongs to
    cropper: null,
    sessionId: cryptoRandom(),
    designId: null,            // ONE design's id, minted fresh on every add-to-cart
                               // that uploads artwork. sessionId is per PAGE LOAD, so
                               // keying uploads on it made a second design overwrite
                               // the first at the same S3 path (see pfc-moulding.js).
    sizeUnit: defaultSizeUnit(),   // 'cm' | 'in' — which preset sizes the list shows
    customUnit: defaultSizeUnit(),   // custom W/H unit — starts in the store's unit
    customW: 0, customH: 0,  // custom print dims in mm
    customBucket: null,
    prevStandardVariant: null,
    // Optional frame + mount add-ons (print-first). Only on framable preset
    // sizes; absorbed into the print Custom Size ladder, one cart line.
    addon: { frameOn: false, mountOn: false, frameCode: null, tier: 'standard', colour: 'White',
             pattern: null, patternLabel: null, stripeHex: null, stripeLabel: null,
             framing: 'standard',     // standard | gallery | float (deep frames = gallery/float only)
             borderMm: 50 },          // mount border each side (mm); outer = print + 2×border
    pers: { on: false, heading: '', line2: '', font: 'Playfair Display', align: 'center', size: 'm',
            logoOn: false, logoImg: null, logoDataUrl: null, logoPos: 'above' },
    addonBucket: null,
    _ftCode: null, _ftImg: null,   // cached frame-texture image for the preview
    // Rotating sample preview (shown until the customer uploads their own image).
    sample: { imgs: [], idx: 0, prevIdx: -1, t: 1, timer: null, raf: null, active: false },
  };

  // The ORIGINAL photo, uploading in the background from the moment it is picked.
  // The print is cut from it server-side using state.cropData (pfc-photo-source.js).
  var photoSrc = window.PFCPhotoSource ? window.PFCPhotoSource.create({
    signerUrl: cfg.gcfUploadUrl, bucket: cfg.uploadBucket, onChange: syncAtcGate,
  }) : null;
  var adding = false;   // add-to-cart request in flight

  function isCustomActive() { return !!(state.variant && state.variant.isCustom); }

  /* ---------- Dimensions ---------- */
  function parseDim(v) {
    var t = (v && v.options && v.options.Size) || (v && v.title) || '';
    var m = t.match(/(\d+)\s*(?:cm|"|in)?\s*[x×]\s*(\d+)/i);
    if (m) return { w: Number(m[1]), h: Number(m[2]) };
    return null;
  }
  // Print dimensions in mm, swapped to the displayed orientation.
  function printDimsMm(v) {
    if (v && v.isCustom) {
      var cw = state.customW || 0, ch = state.customH || 0;
      if (cw === ch) return { w: cw, h: ch };
      var landC = state.orientation === 'landscape';
      return { w: landC ? Math.max(cw, ch) : Math.min(cw, ch),
               h: landC ? Math.min(cw, ch) : Math.max(cw, ch) };
    }
    var d = parseDim(v);
    var baseW = (v && v.widthMm) || (d && d.w) || 0;
    var baseH = (v && v.heightMm) || (d && d.h) || 0;
    if (baseW === baseH) return { w: baseW, h: baseH };
    var landscape = state.orientation === 'landscape';
    return {
      w: landscape ? Math.max(baseW, baseH) : Math.min(baseW, baseH),
      h: landscape ? Math.min(baseW, baseH) : Math.max(baseW, baseH),
    };
  }
  function isSquare(v) {
    var d = printDimsMm(v);
    return d.w && d.h && d.w === d.h;
  }

  function formatMoney(cents) {
    var locale = (document.documentElement.getAttribute('lang') || 'en').toLowerCase().indexOf('en') === 0 ? 'en-GB' : undefined;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (_) {
      return '£' + (cents / 100).toFixed(2);
    }
  }

  /* ---------- Custom-size pricing (area → ladder bucket) ---------- */
  var CP = cfg.customPricing || {};

  // Store-currency price for an arbitrary W×H (mm) — identical AREA formula to
  // scripts/pfc-create-print.py so a custom size equals a defined size's price.
  function customRawPrice(w, h) {
    var areaM2 = (w * h) / 1e6;
    var rawGbp = Math.max(areaM2 * (CP.ppsqm || 128.27), CP.floorGbp || 6);
    if (CP.usd) return Math.max(CP.usdFloor || 10, Math.ceil(rawGbp / 0.72 * 1.30));
    return Math.round(rawGbp * 4) / 4;   // £0.25 steps
  }
  // Presentment (market) FX rate. The bundle ladder lives in a NON-money JSON
  // metafield = store-base currency, which Shopify does NOT convert per market.
  // The cart-transform converts each bucket upcharge by presentmentCurrencyRate
  // (`Math.round(price * rate)`), so on a non-base market (e.g. US store / UK
  // /en-gb market) an unconverted ladder makes the theme show a price the cart
  // never charges. Mirror the function: convert every bucket upcharge by the
  // storefront rate. No-op in the base market (rate = 1).
  // Bundle Pro (v68+) charges a bucket at the HOST line's own multiple --
  // its presentment cost divided by its custom.bundle_host_base -- which folds
  // in FX, the market's price-list % and its rounding rule. The host for every
  // bucket here is the custom (ladder) variant, so read the rate from it rather
  // than once for the page. No base on it -> Shopify.currency.rate, as before.
  function presRate() {
    var cv = customVariant();
    if (window.PFCBundleRate) return window.PFCBundleRate(cv && cv.price, cv && cv.base);
    var r = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
    return r > 0 ? r : 1;
  }
  // Presentment-currency upcharge for a bucket, matching the cart-transform.
  function bucketUpchargeMajor(b) { return addonChargeMajor(b && b.price, presRate()); }
  function matchBucket(rawPrice) {
    var cv = customVariant();
    var ladder = (cv && cv.bundles) || [];
    // Bundle Pro adds the (presentment-converted) upcharge ON TOP of the host
    // (custom) variant base. Match the raw absolute presentment price against
    // base + converted-upcharge so the matched bucket = what the cart charges.
    var base = cv ? Number(cv.price) / 100 : 0;
    var best = null, bestUp = Infinity;
    ladder.forEach(function (b) {
      var up = bucketUpchargeMajor(b);
      if ((up + base) >= rawPrice - 1e-6 && up < bestUp) { best = b; bestUp = up; }
    });
    if (!best && ladder.length) best = ladder.reduce(function (a, b) { return b.price > a.price ? b : a; });
    return best;
  }
  // Major-unit base of the custom (host) variant — added to a bucket's upcharge
  // to get the absolute price to display.
  function customBaseMajor() { var cv = customVariant(); return cv ? Number(cv.price) / 100 : 0; }

  /* ---------- Size dropdown ---------- */
  // Variant title as the customer sees it: 8" x 10" reads 10" x 8" in
  // landscape. Display-only, like the toggle; A-sizes and squares pass through.
  // Same helper in pfc-moulding.js — change all three together.
  function orientedTitle(t) {
    var m = /^(\s*)(\d+(?:\.\d+)?)(\s*(?:"|\u201d|\u2033|cm|mm|in)?)(\s*[x\u00d7X]\s*)(\d+(?:\.\d+)?)(.*)$/.exec(t || '');
    if (!m) return t;
    var a = parseFloat(m[2]), b = parseFloat(m[5]);
    if (a === b || (state.orientation === 'landscape') === (a > b)) return t;
    return m[1] + m[5] + m[3] + m[4] + m[2] + m[6];
  }
  function renderSizeList() {
    if (!elSizeList) return;
    elSizeList.innerHTML = '';
    cfg.variants.forEach(function (v) {
      if (v.isCustom) return;   // custom size lives in the Advanced expander
      if (variantUnit(v) !== state.sizeUnit) return;   // cm/inch filter
      var li = document.createElement('li');
      li.className = 'pfc-moulding__select-option';
      li.setAttribute('role', 'option');
      li.dataset.variantId = String(v.id);
      li.setAttribute('aria-selected', v.id === state.variant.id ? 'true' : 'false');
      var price = document.createElement('span');
      price.className = 'pfc-moulding__select-option-price';
      price.textContent = formatMoney(Number(v.price));
      var label = document.createElement('span');
      label.textContent = orientedTitle(v.title);
      li.appendChild(label);
      li.appendChild(price);
      if (!v.available) li.classList.add('is-unavailable');
      li.addEventListener('click', function () { selectVariant(v); setSizeOpen(false); });
      elSizeList.appendChild(li);
    });
  }
  function setSizeOpen(open) {
    if (!elSizeList || !elSizeTrigger) return;
    elSizeList.hidden = !open;
    elSizeTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    elSizeSelect.classList.toggle('is-open', open);
  }

  /* ---------- Variant selection ---------- */
  function selectVariant(v) {
    state.variant = v;
    var custom = !!v.isCustom;
    if (elSizeValue) elSizeValue.textContent = custom ? 'Custom size' : orientedTitle(v.title);
    if (elSizeList) {
      Array.from(elSizeList.children).forEach(function (li) {
        li.setAttribute('aria-selected', Number(li.dataset.variantId) === v.id ? 'true' : 'false');
      });
    }
    if (elCustom) elCustom.hidden = !custom;

    if (custom) {
      recomputeCustom();
    } else {
      if (elPrice) elPrice.textContent = formatMoney(Number(v.price));
      if (elCompare) {
        var cap = Number(v.compareAtPrice || 0);
        if (cap > Number(v.price)) { elCompare.textContent = formatMoney(cap); elCompare.style.display = ''; }
        else { elCompare.style.display = 'none'; }
      }
    }
    elOrientToggles.forEach(function (w) { w.hidden = custom ? false : isSquare(v); });
    updateSizeChip();
    applyPreviewAspect();
    renderPreview();
    syncSheet();
    refreshAddons();
  }

  function syncSheet() {
    if (elSheetSummary) {
      elSheetSummary.textContent = isCustomActive()
        ? (state.customW && state.customH ? ('Custom ' + fmtPairDisp(state.customW, state.customH)) : 'Custom size')
        : state.variant.title;
    }
    if (elSheetPrice && elPrice) elSheetPrice.textContent = elPrice.textContent;
    if (elBarPrice && elPrice) elBarPrice.textContent = elPrice.textContent;
    // Running total on the Add-to-cart button (drops the need for a separate
    // total row) — mirrors the mount/moulding customiser.
    if (elAtc && !elAtc.disabled && !(photoSrc && photoSrc.failed()) && elPrice) {
      var pt = elPrice.textContent;
      elAtc.textContent = (pt && pt !== '—') ? ('Add to cart · ' + pt) : 'Add to cart';
    }
    updateSizeNote();
    updateAddonChips();
    updateFrameDetail();
  }

  function updateSizeChip() {
    if (!elPrintsizeChip || !elPrintsizeVal) return;
    var d = printDimsMm(state.variant);
    if (d.w && d.h) {
      elPrintsizeChip.hidden = false;
      elPrintsizeVal.textContent = fmtPairDisp(d.w, d.h);
    } else { elPrintsizeChip.hidden = true; }
  }

  /* ---------- Custom size recompute ---------- */
  function toMm(val) {
    if (!val || val <= 0) return 0;
    return state.customUnit === 'in' ? val * 25.4 : val * 10;
  }
  function fmtSide(mm) {
    // Inches to 2dp, trimmed: a typed 5.75" must read back as 5.75", not 5.8".
    return state.customUnit === 'in' ? String(Number((mm / 25.4).toFixed(2))) + '"'
                                     : String(Number((mm / 10).toFixed(1))) + 'cm';
  }
  // Display-unit formatters keyed to the cm/in size toggle so every shown
  // dimension converts to inches in inch mode. Moulding face/depth use 2dp
  // decimal inches in inch mode (US 'rabbet' convention), mm in metric.
  function dispIn() { return state.sizeUnit === 'in'; }
  function fmtDimDisp(mm) {
    if (dispIn()) { var v = mm / 25.4; return (v < 2 ? v.toFixed(2) : v.toFixed(1)) + '"'; }
    return (Math.round(mm / 10 * 10) / 10) + 'cm';
  }
  function fmtPairDisp(w, h) {
    if (dispIn()) return (w / 25.4).toFixed(1) + '×' + (h / 25.4).toFixed(1) + '"';
    return (Math.round(w / 10 * 10) / 10) + '×' + (Math.round(h / 10 * 10) / 10) + 'cm';
  }
  function fmtMouldDisp(mm) { return dispIn() ? ((mm / 25.4).toFixed(2) + '"') : (mm + 'mm'); }
  function setCustomFeedback(text, ok) {
    if (!elCustomFeedback) return;
    elCustomFeedback.textContent = text || '';
    elCustomFeedback.dataset.ok = ok ? 'true' : 'false';
  }
  function recomputeCustom() {
    var w = toMm(parseFloat(elCustomW && elCustomW.value));
    var h = toMm(parseFloat(elCustomH && elCustomH.value));
    state.customW = w; state.customH = h;
    state.customBucket = null;
    // Roll-fed: one side (across the roll) ≤ maxShort (24"/610mm), the other
    // (length) ≤ maxLong (1300mm) — either orientation. NOT a single per-side max.
    var min = CP.minMm || 80;
    var maxShort = CP.maxShortMm || 610;   // roll width — 24"
    var maxLong = CP.maxLongMm || 1300;    // max print length

    function fail(msg) { setCustomFeedback(msg, false); if (elPrice) elPrice.textContent = '—'; applyPreviewAspect(); renderPreview(); syncSheet(); refreshAddons(); }
    if (!w || !h) return fail('Enter a width and height.');
    if (w < min || h < min) return fail('Minimum ' + fmtSide(min) + ' each side.');
    var lo = Math.min(w, h), hi = Math.max(w, h);
    if (lo > maxShort || hi > maxLong) {
      return fail('Up to ' + fmtSide(maxShort) + ' on the shorter side and ' + fmtSide(maxLong) + ' on the longer side.');
    }
    // The typed Width/Height IS the orientation. printDimsMm orients a custom size
    // by state.orientation, which defaults to portrait, so W 16 x H 5.75 used to
    // print 5.75 wide x 16 tall and lock the cropper to a narrow strip of a
    // landscape image (customer report, /products/custom-print, 2026-10).
    var typedOrient = w > h ? 'landscape' : 'portrait';
    if (w !== h && state.orientation !== typedOrient) { setOrientation(typedOrient); renderSizeList(); }

    // customRawPrice is in STORE-BASE currency; convert to presentment so it
    // matches the base + converted-upcharge ladder (no-op in the base market).
    var raw = customRawPrice(w, h) * presRate();
    var bucket = matchBucket(raw);
    if (!bucket) return fail('Size unavailable — please contact us.');
    state.customBucket = { id: bucket.id, price: bucket.price };
    if (elPrice) elPrice.textContent = formatMoney(Math.round((customBaseMajor() + bucketUpchargeMajor(bucket)) * 100));
    if (elCompare) elCompare.style.display = 'none';
    setCustomFeedback(fmtSide(w) + ' × ' + fmtSide(h), true);
    updateSizeChip();
    applyPreviewAspect();
    renderPreview();
    syncSheet();
    refreshAddons();
  }

  /* ---------- Preview ---------- */
  function applyPreviewAspect() {
    if (!elPreview) return;
    // FIXED SQUARE STAGE — mirrors the mount / moulding customisers
    // (pfc-mount.js applyPreviewAspect / pfc-moulding.css aspect-ratio: 1/1) so
    // the preview container is the same size across all customisers. The paper
    // is drawn to scale (MARGIN fit, centred) inside the square stage in
    // renderPreview, so a portrait/landscape print is never stretched.
    elPreview.style.aspectRatio = '1 / 1';
  }
  function currentAspectRatio() {
    var d = printDimsMm(state.variant);
    return d.w ? (d.w / d.h) : 1;
  }
  function drawImageCover(ctx, img, dx, dy, dw, dh) {
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
    if (!iw || !ih) return;
    var s = Math.max(dw / iw, dh / ih);
    ctx.save();
    ctx.beginPath(); ctx.rect(dx, dy, dw, dh); ctx.clip();
    ctx.drawImage(img, dx + (dw - iw * s) / 2, dy + (dh - ih * s) / 2, iw * s, ih * s);
    ctx.restore();
  }
  function renderPreview() {
    // Every size / orientation change lands here, so this is the one place that
    // sees the print ratio move under a confirmed crop.
    if (cropAspectDrifted()) scheduleRecrop();
    // Border slider / mount toggle all land here — re-test the printed-text fit
    // before drawing so the add-on blocks the moment the band goes unprintable.
    updatePersFit();
    pf().update();
    if (!elCanvas) return;
    var ctx = elCanvas.getContext('2d');
    if (!ctx) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = Math.max(320, Math.round(elCanvas.clientWidth || elCanvas.getBoundingClientRect().width));
    var H = Math.max(320, Math.round(elCanvas.clientHeight || elCanvas.getBoundingClientRect().height));
    var BW = W * dpr, BH = H * dpr;
    if (elCanvas.width !== BW || elCanvas.height !== BH) { elCanvas.width = BW; elCanvas.height = BH; }
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, W, H);

    var pd = printDimsMm(state.variant);

    // Composite layout: the print, optionally inside a real MOUNT border (or a
    // float surround), inside a FRAME ring. The outer board = print + 2×border,
    // so the mount adds genuine size and the frame grows to fit it.
    var frameOn = addonActive() && state.addon.frameOn;
    var mountOn = addonActive() && state.addon.mountOn;
    var floatOn = frameOn && state.addon.framing === 'float';
    var board = addonOuterMm();
    var border_mm = addonBorderMm();
    var ratio = (board.w && board.h) ? board.w / board.h : 1;

    // Backdrop.
    var bg = ctx.createLinearGradient(0, 0, 0, H);
    bg.addColorStop(0, '#f9f4ec'); bg.addColorStop(1, '#f1e9da');
    ctx.fillStyle = bg; ctx.fillRect(0, 0, W, H);

    var MARGIN = frameOn ? 0.70 : 0.78;
    var paperW, paperH;
    if (W / H > ratio) { paperH = H * MARGIN; paperW = paperH * ratio; }
    else { paperW = W * MARGIN; paperH = paperW / ratio; }

    var pxPerMm = board.w ? (paperW / board.w) : 1;
    var fb = 0;
    if (frameOn) {
      var frS = frameByCode(state.addon.frameCode);
      fb = Math.max(8, Math.min(46, (frS && frS.widthMm ? Number(frS.widthMm) : 20) * pxPerMm));
    }
    var totalW = paperW + fb * 2, totalH = paperH + fb * 2;
    var ox = (W - totalW) / 2, oy = (H - totalH) / 2;   // frame (outer) origin
    var x0 = ox + fb, y0 = oy + fb;                      // board origin

    // Frame ring.
    if (frameOn) drawFrameRing(ctx, ox, oy, totalW, totalH, fb, dpr);

    // Paper white base + drop shadow.
    ctx.save();
    ctx.shadowColor = 'rgba(60,45,25,0.20)';
    ctx.shadowBlur = frameOn ? 10 : 24; ctx.shadowOffsetX = 2; ctx.shadowOffsetY = frameOn ? 4 : 12;
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(x0, y0, paperW, paperH);
    ctx.restore();

    // Aperture: the print sits centred in the outer board; the surrounding band
    // is the real mount border (or float surround), scaled from mm.
    var ax = x0, ay = y0, aw = paperW, ah = paperH;
    if (border_mm > 0 && board.w) {
      aw = paperW * (pd.w / board.w); ah = paperH * (pd.h / board.h);
      ax = x0 + (paperW - aw) / 2; ay = y0 + (paperH - ah) / 2;
    }

    // Float: soft drop shadow under the proud print so it reads as floating.
    if (floatOn) {
      ctx.save();
      var fg = pxPerMm * FLOAT_GAP_MM;
      ctx.shadowColor = 'rgba(40,30,18,0.34)';
      ctx.shadowBlur = Math.max(8, Math.min(22, fg * 0.9));
      ctx.shadowOffsetX = 1; ctx.shadowOffsetY = Math.max(3, Math.min(10, fg * 0.4));
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(ax - 1, ay - 1, aw + 2, ah + 2);
      ctx.restore();
    }

    if (state.userImg) {
      drawImageCover(ctx, state.userImg, ax, ay, aw, ah);
    } else if (sampleReady()) {
      drawSampleAperture(ctx, ax, ay, aw, ah);
    } else {
      ctx.fillStyle = '#f3efe7'; ctx.fillRect(ax, ay, aw, ah);
      ctx.fillStyle = 'rgba(74,62,48,0.45)';
      ctx.font = '600 13px ' + UI_FONT;
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.fillText('Add your photo to preview', ax + aw / 2, ay + ah / 2);
    }

    // Mount border ring on top (covers the print's outer edge), pattern-filled.
    // Skipped under Float framing (the surround is a plain white board, no mount).
    if (mountOn && !floatOn) {
      ctx.save();
      ctx.beginPath();
      ctx.rect(x0, y0, paperW, paperH);
      ctx.rect(ax, ay, aw, ah);
      ctx.clip('evenodd');
      drawMountFillP(ctx, x0, y0, paperW, paperH, board.w || 210);
      ctx.restore();
      // Premium 'accent' keyline: a thin coloured ring in the border just outside
      // the aperture (board stays the base colour).
      if (state.addon.pattern === 'accent') {
        var accPx = paperW / (board.w || 210);
        var accPat = patternByKeyP('accent');
        var accGap = (accPat.gapMm || 10) * accPx;
        ctx.strokeStyle = state.addon.stripeHex || '#23395d';
        ctx.lineWidth = Math.max(1, (accPat.lineMm || 1.4) * accPx);
        ctx.strokeRect(ax - accGap, ay - accGap, aw + accGap * 2, ah + accGap * 2);
      }
      // Aperture bevel.
      ctx.strokeStyle = 'rgba(0,0,0,0.18)'; ctx.lineWidth = 1;
      ctx.strokeRect(ax - 0.5, ay - 0.5, aw + 1, ah + 1);
      // Printed text/logo in the bottom mount border. Inset to MATCH the mount
      // customiser's geometry (pfc-mount.js: pPad top, pPad*1.6 bottom, pPad
      // sides) so the text renders at the same size across customisers.
      if (isPersActive()) {
        var edge = PERS_EDGE_MM * pxPerMm, gap = PERS_GAP_MM * pxPerMm;
        var apBottom = ay + ah;
        var bandTop = apBottom + gap, bandBot = (y0 + paperH) - edge;
        if ((bandBot - bandTop) > 8 && (paperW - edge * 2) > 8) {
          drawPersonalisationP(ctx, persRect(x0, paperW, bandTop, bandBot, pxPerMm),
                               persInk(), persCapMmP() * pxPerMm, PERS_BOXPAD_MM * pxPerMm);
          var bpad = PERS_BOXPAD_MM * pxPerMm;
          syncPersSizeSteps((paperW - edge * 2) - bpad * 2, (bandBot - bandTop) - bpad * 2, pxPerMm);
        }
      }
    }

    // Subtle surface shade + edge on the visible image.
    var surf = ctx.createLinearGradient(ax, ay, ax, ay + ah);
    surf.addColorStop(0, 'rgba(255,255,255,0.06)');
    surf.addColorStop(1, 'rgba(0,0,0,0.05)');
    ctx.fillStyle = surf; ctx.fillRect(ax, ay, aw, ah);
    ctx.strokeStyle = 'rgba(0,0,0,0.10)'; ctx.lineWidth = 1;
    ctx.strokeRect(x0 + 0.5, y0 + 0.5, paperW - 1, paperH - 1);
  }

  /* ---------- Rotating sample preview (pre-upload) ---------- */
  // Cycle curated sample shots in the aperture until the customer uploads, so a
  // cold visitor instantly sees what the product is. Always badged "Sample" with
  // an "upload your own photo" caption so it's never mistaken for their order.
  function roundRectP(c, x, y, w, h, r) {
    c.beginPath();
    c.moveTo(x + r, y); c.arcTo(x + w, y, x + w, y + h, r);
    c.arcTo(x + w, y + h, x, y + h, r); c.arcTo(x, y + h, x, y, r);
    c.arcTo(x, y, x + w, y, r); c.closePath();
  }
  function sampleReady() {
    var s = state.sample, im = s.imgs[s.idx];
    return s.active && !state.userImg && im && im.complete && im.naturalWidth > 0;
  }
  function startSamples() {
    var s = state.sample;
    var urls = (cfg.sampleImages || []).filter(Boolean);
    if (!urls.length || state.userImg) return;
    s.imgs = urls.map(function (u) {
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = renderPreview; im.src = u; return im;
    });
    s.idx = 0; s.prevIdx = -1; s.t = 1; s.active = true;
    if (urls.length > 1) s.timer = setInterval(advanceSample, 3400);
    renderPreview();
  }
  function advanceSample() {
    var s = state.sample;
    if (!s.active || state.userImg || s.imgs.length < 2) return;
    s.prevIdx = s.idx;
    s.idx = (s.idx + 1) % s.imgs.length;
    var start = performance.now(), DUR = 650;
    if (s.raf) cancelAnimationFrame(s.raf);
    (function step(now) {
      s.t = Math.min(1, (now - start) / DUR);
      renderPreview();
      if (s.t < 1) s.raf = requestAnimationFrame(step);
    })(start);
  }
  function stopSamples() {
    var s = state.sample;
    s.active = false;
    if (s.timer) { clearInterval(s.timer); s.timer = null; }
    if (s.raf) { cancelAnimationFrame(s.raf); s.raf = null; }
  }
  function drawSampleAperture(ctx, ax, ay, aw, ah) {
    var s = state.sample, cur = s.imgs[s.idx], prev = s.imgs[s.prevIdx];
    if (s.prevIdx >= 0 && s.t < 1 && prev && prev.complete && prev.naturalWidth) {
      drawImageCover(ctx, prev, ax, ay, aw, ah);
      ctx.save(); ctx.globalAlpha = s.t; drawImageCover(ctx, cur, ax, ay, aw, ah); ctx.restore();
    } else {
      drawImageCover(ctx, cur, ax, ay, aw, ah);
    }
    // Tint so the overlay reads as chrome, not part of the artwork.
    ctx.fillStyle = 'rgba(18,12,4,0.16)'; ctx.fillRect(ax, ay, aw, ah);
    // "Sample" pill, top-left.
    ctx.font = '700 11px ' + UI_FONT; ctx.textBaseline = 'middle'; ctx.textAlign = 'left';
    var label = 'SAMPLE', pad = 7, ph = 20;
    var pw = ctx.measureText(label).width + pad * 2, px = ax + 10, py = ay + 10;
    ctx.fillStyle = 'rgba(0,0,0,0.6)'; roundRectP(ctx, px, py, pw, ph, 4); ctx.fill();
    ctx.fillStyle = '#fff'; ctx.fillText(label, px + pad, py + ph / 2 + 0.5);
    // Bottom caption strip.
    var ch = Math.max(26, ah * 0.14);
    var grad = ctx.createLinearGradient(0, ay + ah - ch, 0, ay + ah);
    grad.addColorStop(0, 'rgba(0,0,0,0)'); grad.addColorStop(1, 'rgba(0,0,0,0.6)');
    ctx.fillStyle = grad; ctx.fillRect(ax, ay + ah - ch, aw, ch);
    ctx.fillStyle = '#fff'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    var cap = 'Upload your own photo to preview it here';
    var fs = 12;
    ctx.font = '600 ' + fs + 'px ' + UI_FONT;
    while (fs > 9 && ctx.measureText(cap).width > aw - 16) { fs -= 1; ctx.font = '600 ' + fs + 'px ' + UI_FONT; }
    ctx.fillText(cap, ax + aw / 2, ay + ah - ch / 2);
  }

  /* ---------- Upload / crop ---------- */
  function openCropperWithUrl(url) {
    // Hold a decoded copy of the ORIGINAL. Cropper owns elCropImg and tears it
    // down on close, and the object URL dies with the tab — without this there
    // is nothing left to re-cut from when the print ratio changes later.
    if (!state.srcImg || state.srcImg.src !== url) {
      var si = new Image();
      // Only if this is still the photo in play — a cancelled pick must not land.
      si.onload = function () { if (state.originalUrl === url) { state.srcImg = si; state.cropStale = false; } };
      si.src = url;
    }
    // A file the browser can't decode never fires load: without this the cropper
    // sat open and blank. Close it, put the previous photo back and say why. The
    // stale load listener of a failed open disarms itself on the next load.
    var failed = false;
    elCropImg.onerror = function () {
      elCropImg.onerror = null;
      failed = true;
      if (state.originalUrl !== url) return;
      cancelCrop();
      uploadNotice('We couldn’t open that file. Please use a JPG, PNG, HEIC or PDF.', 'error');
    };
    elCropImg.src = url;
    elCropModal.dataset.open = 'true';
    elCropImg.addEventListener('load', function once() {
      elCropImg.removeEventListener('load', once);
      if (failed) return;
      elCropImg.onerror = null;
      if (state.cropper) { try { state.cropper.destroy(); } catch (_) {} }
      if (typeof Cropper === 'undefined') {
        state.previewDataUrl = url; commitPhoto(); applyPreview(); closeCropper(); return;
      }
      var opts = {
        aspectRatio: currentAspectRatio(),
        viewMode: 1, autoCropArea: 1, responsive: true,
        background: false, zoomable: true, movable: true,
      };
      if (state.cropData) {
        var saved = state.cropData;
        opts.ready = function () { try { state.cropper.setData(saved); } catch (_) {} };
      }
      state.cropper = new Cropper(elCropImg, opts);
    });
  }
  function openCropper(file) {
    var UN = window.PFCUploadNormalise;
    if (UN && UN.needsConversion(file)) {
      // HEIC / PDF → JPEG first; the converted file re-enters as a plain JPEG.
      uploadNotice(UN.busyText(file), 'busy');
      UN.normalise(file).then(function (r) { uploadNotice(r.note || '', 'info'); openCropper(r.file); },
        function (err) { uploadNotice(err.message, 'error'); });
      return;
    }
    if (photoSrc && !photoSrc.start(file)) {
      uploadNotice('That photo is over ' + Math.round(window.PFCPhotoSource.MAX_BYTES / 1048576) + 'MB — please choose a smaller file.', 'error');
      return;
    }
    flashStatus('');   // a previous upload error no longer applies
    // Provisional until Confirm: keep what was confirmed before so Cancel can put
    // it back (see cancelCrop). A second pick before confirming keeps the first
    // stash — Cancel always returns to the last CONFIRMED photo.
    if (!state.pendingPrev) {
      state.pendingPrev = { originalUrl: state.originalUrl, cropData: state.cropData, srcImg: state.srcImg };
    } else if (state.originalUrl) {
      try { URL.revokeObjectURL(state.originalUrl); } catch (_) {}
    }
    var url = URL.createObjectURL(file);
    state.originalUrl = url; state.cropData = null; state.srcImg = null;
    openCropperWithUrl(url);
  }
  // The crop on screen now belongs to the photo being uploaded.
  function commitPhoto() {
    var p = state.pendingPrev;
    state.pendingPrev = null;
    if (p && p.originalUrl && p.originalUrl !== state.originalUrl) {
      try { URL.revokeObjectURL(p.originalUrl); } catch (_) {}
    }
    if (photoSrc) { photoSrc.commit(); state.cropFor = photoSrc.state().url; }
  }
  function cancelCrop() {
    var p = state.pendingPrev;
    if (p) {
      state.pendingPrev = null;
      if (state.originalUrl && state.originalUrl !== p.originalUrl) {
        try { URL.revokeObjectURL(state.originalUrl); } catch (_) {}
      }
      state.originalUrl = p.originalUrl; state.cropData = p.cropData; state.srcImg = p.srcImg;
      if (photoSrc) photoSrc.revert();
    }
    closeCropper();
  }
  function reopenCropper() { if (state.originalUrl) openCropperWithUrl(state.originalUrl); }
  function confirmCrop() {
    if (!state.cropper) { closeCropper(); return; }
    try { state.cropData = state.cropper.getData(true); } catch (_) { state.cropData = null; }
    // Preview only. The print is cut from the uploaded original with cropData,
    // so there is no full-resolution encode here any more.
    var prev = state.cropper.getCroppedCanvas({ maxWidth: 900, maxHeight: 900, imageSmoothingQuality: 'medium' });
    state.previewDataUrl = prev.toDataURL('image/jpeg', 0.85);
    state.croppedAspect = currentAspectRatio();
    state.cropStale = false;
    commitPhoto();
    applyPreview(); closeCropper();
  }
  /*
   * Reshape the crop when the PRINT RATIO changes under a crop that is already
   * confirmed — an orientation flip, or a size with a different ratio.
   *
   * Without this the two halves of the order disagree: `Orientation` is computed
   * fresh at add-to-cart from the live toggle, while the crop stays frozen at
   * whatever ratio was current when Confirm was pressed. The
   * on-canvas preview hides it, because drawImageCover cover-crops the stale
   * JPEG into the new paper and looks right. Order PFC-UK-1338458 was placed
   * that way: labelled "Custom 250×200mm / Landscape", both S3 files portrait 4:5.
   *
   * The customer's chosen subject is kept — same centre, box reshaped to the new
   * ratio and clamped inside the image — so a flip needs no second visit to the
   * cropper.
   */
  function cropToDataUrl(img, box, maxPx, q) {
    var s = Math.min(1, maxPx / Math.max(box.width, box.height));
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(box.width * s));
    c.height = Math.max(1, Math.round(box.height * s));
    var ctx = c.getContext('2d');
    if (!ctx) return null;
    ctx.imageSmoothingQuality = 'high';
    ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, c.width, c.height);
    ctx.drawImage(img, box.x, box.y, box.width, box.height, 0, 0, c.width, c.height);
    return c.toDataURL('image/jpeg', q);
  }
  // Re-cut off the back of a short debounce: a typed size or a dragged opening
  // fires renderPreview on every keystroke, and a canvas encode per keystroke
  // would stutter. The on-canvas preview is already correct meanwhile
  // (it cover-crops), and add-to-cart re-checks, so nothing escapes on the gap.
  var recropTimer = null;
  function scheduleRecrop() {
    if (recropTimer) clearTimeout(recropTimer);
    recropTimer = setTimeout(function () {
      recropTimer = null;
      if (!cropAspectDrifted()) return;
      if (recropToAspect()) applyPreview();
      else state.cropStale = true;   // original gone (reload) — add-to-cart will ask
    }, 150);
  }

  function recropToAspect() {
    var img = state.srcImg, d = state.cropData, ar = currentAspectRatio();
    if (!img || !img.naturalWidth || !d || !d.width || !d.height || !ar) return false;
    var iw = img.naturalWidth, ih = img.naturalHeight;
    // Keep the crop's height and reshape the width to the new ratio, shrinking
    // to fit when that runs past an edge. Portrait→landscape therefore keeps the
    // full vertical extent of what they framed and widens into the photo.
    var nh = Math.min(d.height, ih), nw = nh * ar;
    if (nw > iw) { nw = iw; nh = nw / ar; }
    if (nh > ih) { nh = ih; nw = nh * ar; }
    var cx = d.x + d.width / 2, cy = d.y + d.height / 2;
    var box = {
      x: Math.max(0, Math.min(iw - nw, cx - nw / 2)),
      y: Math.max(0, Math.min(ih - nh, cy - nh / 2)),
      width: nw, height: nh,
    };
    var prev = cropToDataUrl(img, box, 900, 0.85);
    if (!prev) return false;
    state.cropData = box;
    state.previewDataUrl = prev;
    state.croppedAspect = ar;
    state.cropStale = false;
    return true;
  }
  // True when the confirmed crop no longer matches the print ratio.
  function cropAspectDrifted() {
    var ar = currentAspectRatio();
    return !!(state.previewDataUrl && state.croppedAspect && ar
      && Math.abs(state.croppedAspect - ar) > 0.001);
  }

  function closeCropper() {
    elCropModal.dataset.open = 'false';
    if (state.cropper) { try { state.cropper.destroy(); } catch (_) {} state.cropper = null; }
    elCropImg.src = '';
  }
  function applyPreview() {
    stopSamples();
    if (elUpload) elUpload.dataset.hasImage = 'true';
    if (elPreview) elPreview.dataset.hasImage = 'true';
    if (elUploadTitle) elUploadTitle.textContent = 'Looking good — Recrop or Replace below';
    var img = new Image();
    img.onload = function () { state.userImg = img; renderPreview(); };
    img.src = state.previewDataUrl;
  }

  /* ---------- S3 upload ---------- */
  function dataURLToBlob(dataUrl) {
    var parts = dataUrl.split(','), mime = (parts[0].match(/:(.*?);/) || [])[1] || 'image/jpeg';
    var bin = atob(parts[1]), n = bin.length, u8 = new Uint8Array(n);
    while (n--) u8[n] = bin.charCodeAt(n);
    return new Blob([u8], { type: mime });
  }
  // The id that identifies ONE design. Per-add while an add carries artwork;
  // otherwise the page-load sessionId, so identical artwork-free adds still merge
  // into a single qty-2 line.
  function designKey() { return state.designId || state.sessionId; }

  // What the customer sees of their order at checkout, in the order email and
  // on the order status page. Bundle Pro's expand drops every plain property on
  // a bundled line and keeps only the hidden `_addons_custom` blob; since app
  // v69 it re-attaches the keys listed in `_addon_bundle_pro_display` as
  // VISIBLE properties. Default-deny: only these keys, in this order, under
  // these labels. Print file, Photo original/crop, Personalisation image, Frame
  // Only, Mount external, Opening size and the session id stay hidden; the
  // full record still goes to `_addons_custom` untouched.
  // Same list in pfc-moulding.js, pfc-mount.js and pfc-print-app.js — keep in step.
  var BUNDLE_DISPLAY = [
    ['Image Preview', 'Your design'], ['Board preview', 'Board preview'],
    ['Map', 'Map'], ['Size', 'Size'], ['Orientation', 'Orientation'], ['Print size', 'Print size'], ['Finished size', 'Finished size'],
    ['Frame size', 'Frame size'], ['Frame', 'Frame'], ['Moulding', 'Moulding'], ['Finish', 'Finish'],
    ['Framing style', 'Framing style'], ['Float border', 'Float border'], ['Paper edge', 'Paper edge'], ['Frame opening', 'Frame opening'], ['Mount', 'Mount'], ['Mount colour', 'Mount colour'],
    ['Mount border', 'Mount border'], ['Mount opening', 'Mount opening'], ['Board colour', 'Board colour'],
    ['Border', 'Border'], ['Style', 'Style'], ['Pattern', 'Pattern'], ['Pattern colour', 'Pattern colour'],
    ['Glazing', 'Glazing'], ['Paper', 'Paper'], ['Fit', 'Fit'], ['Print', 'Print'], ['Supplied as', 'Supplied as'],
    ['Personalisation', 'Personalisation'], ['Printed text', 'Printed text'], ['Font', 'Font'], ['Alignment', 'Alignment']
  ];
  /** `_addon_bundle_pro_display` for one line (JSON string), or null if nothing qualifies. */
  function bundleDisplayFor(src, logoUrl) {
    var out = {}, n = 0;
    BUNDLE_DISPLAY.forEach(function (pair) {
      var v = src[pair[0]];
      if (typeof v !== 'string' && typeof v !== 'number') return;
      v = String(v).trim();
      if (v) { out[pair[1]] = v; n++; }
    });
    // The customer's ORIGINAL logo file (uploaded with the personalisation).
    if (logoUrl) { out['Your logo'] = logoUrl; n++; }
    return n ? JSON.stringify(out) : null;
  }
  /** The uploaded original logo, when the printed personalisation has one. */
  function persLogoUrl(spec) { return spec && spec.logo && spec.logo.url ? spec.logo.url : null; }

  // What Bundle Pro charges for an add-on, in presentment MAJOR units. Mirrors
  // the cart transform's addonCharge (app v69+): with no conversion at all
  // (rate exactly 1: the shop's own currency, no price-list adjustment) the
  // add-on is charged to the penny; converted markets stay whole units. Quoting
  // Math.round(price * rate) everywhere showed a £8.25 mount as £8 while the
  // cart charged £8.25. Same function in pfc-moulding.js, pfc-mount.js and
  // pfc-print-app.js, and in the studio's convertBundle — keep in step.
  function addonChargeMajor(price, rate) {
    var p = Number(price) || 0, r = Number(rate);
    if (r === 1) return Math.round(p * 100) / 100;
    return Math.round(p * r);
  }

  // Sizes defined in INCHES are carried as whole mm (11" -> 279mm, 14" -> 356mm),
  // so converting those mm back gives 10.98×14.02". When a size was defined in
  // inches, take the exact inches from its label ('11" x 14"'), matched to the
  // mm pair so orientation follows; otherwise null (metric sizes).
  // Same helper in pfc-moulding.js and pfc-mount.js - keep in step.
  function exactInchPair(wMm, hMm, label) {
    var m = String(label || '').match(/(\d+(?:\.\d+)?)\s*["”]\s*[x×]\s*(\d+(?:\.\d+)?)\s*["”]/i);
    if (!m) return null;
    var a = parseFloat(m[1]), b = parseFloat(m[2]);
    var keep = Math.abs(wMm - a * 25.4) + Math.abs(hMm - b * 25.4);
    var swap = Math.abs(wMm - b * 25.4) + Math.abs(hMm - a * 25.4);
    var p = keep <= swap ? { w: a, h: b } : { w: b, h: a };
    // Only when the mm really are this size, rounded to whole mm.
    return (Math.abs(wMm - p.w * 25.4) <= 1 && Math.abs(hMm - p.h * 25.4) <= 1) ? p : null;
  }
  function fmtInch(x) { return String(Number(x.toFixed(2))); }

  function uploadKey(suffix) {
    var d = new Date(), ym = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
    return (cfg.uploadPrefix || 'print') + '/' + ym + '/' + designKey() + '/' + state.variant.id + '-' + suffix;
  }
  function publicS3Url(key) { return 'https://' + cfg.uploadBucket + '.s3.eu-west-2.amazonaws.com/' + key; }
  function uploadOne(dataUrl, key) {
    var form = new URLSearchParams();
    form.append('bucket', cfg.uploadBucket); form.append('key', key); form.append('type', 'put');
    return fetch(cfg.gcfUploadUrl, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: form })
      .then(function (r) { return r.text(); })
      .then(function (signedUrl) {
        return fetch(signedUrl, { method: 'PUT', headers: { 'Content-Type': 'image/jpeg' }, body: dataURLToBlob(dataUrl) });
      });
  }
  // Only the small preview goes up here — the original is already uploaded
  // (photoSrc) and the print is cut from it.
  function uploadImage() {
    var prevKey = uploadKey('preview.jpg');
    return uploadOne(state.previewDataUrl, prevKey)
      .then(function (r) { if (r && r.ok === false) throw new Error('preview upload ' + r.status); })
      .then(function () { return { previewUrl: publicS3Url(prevKey) }; });
  }

  // Add-to-cart is unusable while the original is still uploading: an order must
  // never reference an original that is not in S3. Failed → the button retries.
  function syncAtcGate() {
    if (!elAtc) return;
    var ph = photoSrc ? photoSrc.state() : { status: 'idle' };
    if (ph.status === 'uploading') {
      elAtc.disabled = true;
      elAtc.textContent = 'Uploading photo… ' + Math.floor(ph.progress * 100) + '%';
      return;
    }
    if (ph.status === 'error') {
      elAtc.disabled = adding;
      elAtc.textContent = 'Photo upload failed — tap to retry';
      return;
    }
    elAtc.disabled = adding;
    if (!adding) syncSheet();   // restores the "Add to cart · £x" label
  }

  /* ---------- ATC ---------- */
  function addToCart() {
    if (adding) return;
    if (photoSrc && photoSrc.failed()) { flashStatus('Retrying your photo upload…'); photoSrc.retry(); return; }
    if (photoSrc && photoSrc.busy()) return;   // button is disabled; belt and braces
    if (isCustomActive() && !state.customBucket) { flashStatus('Enter a valid custom size first.'); return; }
    if (addonActive() && !state.addonBucket) { flashStatus('This frame/mount combination is unavailable — please adjust.'); return; }
    if (isPersActive()) { var pErr = pf().addError(); if (pErr) { flashStatus(pErr); return; } }
    if (cfg.requireImage && !state.previewDataUrl) { flashStatus('Add your photo or artwork first.'); return; }
    // Ratio moved and the original was gone, so the files on hand are cut to the
    // wrong shape. Never let that reach the cart — it prints the wrong picture.
    if (state.cropStale || (cropAspectDrifted() && !recropToAspect())) {
      if (state.originalUrl) { flashStatus('Please re-crop your photo for this size.'); reopenCropper(); }
      else { flashStatus('Please add your photo again for this size.'); elFileInput && elFileInput.click(); }
      return;
    }
    // A photo is on the design: the order needs the original and the exact box
    // it was cut to, measured against the displayed (EXIF-applied) image.
    var photo = null;
    if (state.previewDataUrl) {
      // The crop must have been confirmed against THIS upload — anything else would
      // cut the print from a different photo than the one on screen.
      if (!photoSrc || !photoSrc.ready() || !state.srcImg || !state.srcImg.naturalWidth
          || state.cropFor !== photoSrc.state().url) {
        flashStatus('Please add your photo again.'); elFileInput && elFileInput.click(); return;
      }
      photo = {
        url: photoSrc.state().url,
        crop: window.PFCPhotoSource.cropSpec(state.cropData, state.srcImg.naturalWidth, state.srcImg.naturalHeight),
      };
    }
    // Mint this add's design id BEFORE any upload key is built, so two designs
    // added from one page load get distinct S3 paths and distinct cart lines.
    // No artwork on this add → keep the session id and merge as before.
    state.designId = (photo || isPersActive()) ? cryptoRandom() : null;

    adding = true;
    elAtc.disabled = true;
    var prep;
    if (photo) {
      flashStatus('Adding to cart…');
      prep = uploadImage().then(function (up) { up.photo = photo; return up; });
    } else { flashStatus('Adding to cart…'); prep = Promise.resolve(null); }
    // Printed text/logo: render + upload the personalisation PNG alongside.
    var persJob = Promise.resolve(null);
    if (isPersActive()) {
      var persPng = renderPersExportP();
      if (persPng) { flashStatus('Uploading…'); persJob = uploadPersImageP(persPng); }
    }
    Promise.all([prep, persJob]).then(function (r) { return postCart(r[0], r[1]); })
      .then(function (res) { if (!res.ok) throw new Error(res.statusText); return res.json(); })
      .then(function (data) { injectCartSections(data); flashStatus('Added to cart.'); openCartDrawer(); })
      .catch(function (err) { console.error('PFC print ATC error', err); flashStatus('Could not add to cart — please try again.'); })
      .finally(function () { adding = false; syncAtcGate(); });
  }

  function postCart(uploaded, persUp) {
    var pv = state.variant;                       // the chosen PRINT variant
    var addon = addonActive() && state.addonBucket;
    var custom = !addon && !!pv.isCustom;
    // When add-ons are on, the cart line is the print Custom Size variant (the
    // ladder host); the real print size + frame/mount travel as properties.
    var lineVariant = (addon || custom) ? customVariant() : pv;
    var d = printDimsMm(pv);
    // The order speaks the unit the size was defined in: the one a custom size was
    // typed in, else... Inch values are exact (typed inches, or the inch size
    // label), never rounded mm converted back.
    // ...the size's OWN unit, not the list it was picked from: an A4 bought from
    // the inch list stays metric (its name already says what it is).
    var orderIn = pv.isCustom ? state.customUnit === 'in' : !!exactInchPair(d.w, d.h, pv.title);
    var printIn = !orderIn ? null
      : pv.isCustom ? { w: d.w / 25.4, h: d.h / 25.4 }
      : (exactInchPair(d.w, d.h, pv.title) || { w: d.w / 25.4, h: d.h / 25.4 });
    var sizeLabel = pv.isCustom
      ? (orderIn ? 'Custom ' + fmtInch(printIn.w) + '×' + fmtInch(printIn.h) + '"'
                 : 'Custom ' + Math.round(d.w) + '×' + Math.round(d.h) + 'mm')
      : (pv.options && pv.options.Size ? pv.options.Size : pv.title);
    var props = {
      'Size': sizeLabel,
      'Orientation': (d.w && d.h) ? (d.w >= d.h ? 'Landscape' : 'Portrait') : '',
      'id': designKey(),
    };

    if (addon) {
      // Frame + mount absorbed: one line, choices as properties.
      var suf = currentSuffix();
      var supplied = ['Print'];
      var outer = addonOuterMm();
      var border = addonBorderMm();
      // Finished (outer) size = print + 2×border. Recorded whenever a mount/float
      // border is present so the workshop cuts frame + mount to that size.
      if (border > 0) props['Finished size'] = orderIn
        ? fmtInch(printIn.w + 2 * border / 25.4) + '×' + fmtInch(printIn.h + 2 * border / 25.4) + '"'
        : Math.round(outer.w) + '×' + Math.round(outer.h) + 'mm';
      // Bespoke whenever the outer isn't a stocked print size (custom, or any
      // mount/float border) — no stocked SKU applies, the piece is cut to size.
      var bespoke = pv.isCustom || border > 0;
      if (state.addon.frameOn) {
        var f = frameByCode(state.addon.frameCode);
        if (f) {
          props['Frame'] = f.name;
          if (!bespoke && f.sizes[suf]) props['_frame_sku'] = f.sizes[suf].sku;
          props['_frame_code'] = f.code || '';
          if (bespoke) props['_frame_bespoke'] = '1';
          supplied.push('frame');
        }
        // Deep frames carry their framing style (Standard is implicit/omitted).
        if (state.addon.framing && state.addon.framing !== 'standard') {
          props['Framing'] = state.addon.framing === 'float'
            ? ('Float-mount (' + FLOAT_GAP_MM + 'mm surround)') : 'Gallery';
          if (state.addon.framing === 'float') props['_float_gap_mm'] = String(FLOAT_GAP_MM);
        }
      }
      if (state.addon.mountOn) {
        var t = mountTierCfg();
        var detail = state.addon.pattern
          ? ((state.addon.patternLabel || 'Patterned') + (state.addon.stripeLabel ? ' / ' + state.addon.stripeLabel : ''))
          : (state.addon.colour || 'White');
        props['Mount'] = (t && t.label ? t.label : 'Standard') + ' — ' + detail;
        props['Mount border'] = orderIn ? fmtInch(border / 25.4) + '"' : Math.round(border) + 'mm';
        if (!bespoke && t && t.sizes && t.sizes[suf]) props['_mount_sku'] = t.sizes[suf].sku;
        props['_mount_bespoke'] = '1';
        supplied.push('mount');
        // Printed text/logo on the mount border (Decision A: Premium tier).
        if (isPersActive()) {
          var persText = [state.pers.heading, state.pers.line2].filter(function (s) { return s && s.trim(); }).join(' / ');
          props['Personalisation'] = persHasLogo() ? ('Text + logo (' + state.pers.logoPos + ')') : 'Text';
          props['Printed text'] = persText || '(logo only)';
          props['Alignment'] = state.pers.align.charAt(0).toUpperCase() + state.pers.align.slice(1);
          props['Font'] = state.pers.font;
          if (persUp && persUp.url) { props['Personalisation image'] = persUp.url; props['_pers_file'] = persUp.url; }
          supplied.push('printed text');
        }
      }
      props['Supplied as'] = supplied.join(' + ');
      props['_pfc_custom_print'] = '1';
      props['_print_sku'] = pv.sku || '';
      props['_print_w_mm'] = Math.round(d.w);
      props['_print_h_mm'] = Math.round(d.h);
      props['_upsell_bundles_pro_selected'] = state.addonBucket.id;
      props['_true_price'] = ((Number(pv.price) + framePriceCents() + mountPriceCents()) / 100).toFixed(2);
      if (state.addonBucket.name) props['_addon_bundle_pro_title'] = state.addonBucket.name;
    } else {
      props['Supplied as'] = 'Print only — no frame, no mount';
    }

    if (uploaded) {
      props['Image Preview'] = uploaded.previewUrl;
      // Cart-line thumbnail for the drawer + cart page. SAFE property name (NOT
      // `_addon_bundle_pro_image`, which is Bundle Pro's Function input — an S3
      // URL there breaks the cart-transform reprice). The snippets read this as a
      // fallback purely for display; the Function never sees it.
      props['_pfc_cart_image'] = uploaded.previewUrl;
      // `_addon_bundle_pro_image` feeds Bundle Pro's cart-transform EXPAND
      // `image` property, which per Shopify's cart-transform docs accepts ONLY a
      // Shopify-CDN image URL. Our uploads are S3 URLs, so the expand operation
      // fails on a bundle line and the whole transform is dropped — the line
      // never reprices and falls back to the bare host-variant base (£6 / $14).
      // (Proven live 2026-06-26: the SAME line repriced the moment this prop was
      // gone.) So only attach it on a plain (non-bundle) line, where there's no
      // expand to break. Display only — the print travels as `_photo_*` below.
      if (!addon && !custom) props['_addon_bundle_pro_image'] = uploaded.previewUrl;
      // The untouched original + the box to cut from it. The print-files page
      // cuts the master from these (no cropped full-res is stored).
      if (uploaded.photo) {
        props['_photo_src'] = uploaded.photo.url;
        props['_photo_crop'] = uploaded.photo.crop;
      }
    }
    // Custom size (no add-ons): charge via the matched area ladder bucket.
    if (custom && state.customBucket) {
      var cv = customVariant();
      var bundle = ((cv && cv.bundles) || []).find(function (b) { return b.id === state.customBucket.id; });
      props['_upsell_bundles_pro_selected'] = state.customBucket.id;
      if (bundle && bundle.name) props['_addon_bundle_pro_title'] = bundle.name;
    }
    // Bundle Pro's cart-transform EXPAND replaces this source line with its
    // components; only `_addon_bundle_pro_personalisations` survives the split.
    // Mirror every human-readable prop into it when a bundle is attached, else
    // Frame/Mount/size/Supplied-as never reach the Shopify order. No bundle =>
    // no expand => plain props survive, skip.
    if (props['_upsell_bundles_pro_selected']) {
      var carry = {};
      Object.keys(props).forEach(function (k) {
        if (k.charAt(0) !== '_') carry[k] = props[k];
      });
      // Only the personalisations JSON survives the expand (it lands as the
      // underscore `_addons_custom` blob => admin-only), and the copy above skips
      // underscore keys — so the photo would vanish from bundle lines without these.
      if (props['_photo_src']) carry['Photo original'] = props['_photo_src'];
      if (props['_photo_crop']) carry['Photo crop'] = props['_photo_crop'];
      if (props['Printed text'] && lastPersRenderSpec) carry['_pers_render'] = lastPersRenderSpec;
      props['_addon_bundle_pro_personalisations'] = JSON.stringify(carry);
      var display = bundleDisplayFor(carry, props['Printed text'] ? persLogoUrl(lastPersRenderSpec) : null);
      if (display) props['_addon_bundle_pro_display'] = display;
    }
    // Friendly cart-line name — the host variant title is just "Custom Size".
    // The snippets show this in place of the generic product title.
    var lineTitle = 'Custom Print';
    if (addon) {
      var hasF = state.addon.frameOn, hasM = state.addon.mountOn;
      lineTitle = (hasF && hasM) ? 'Custom Framed & Mounted Print'
                : hasF ? 'Custom Framed Print'
                : hasM ? 'Custom Mounted Print' : 'Custom Print';
    } else if (custom) {
      lineTitle = 'Custom Size Print';
    }
    props['_pfc_line_title'] = lineTitle;
    var body = {
      items: [{ id: lineVariant.id, quantity: 1, properties: props }],
      sections: 'cart-drawer,cart-icon-bubble,cart-live-region-text,header-drawer'
    };
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
    });
  }

  function injectCartSections(data) {
    if (!data.sections) return;
    try {
      if (data.sections['cart-drawer'] && document.querySelector('cart-drawer')) {
        var v1 = document.createElement('div'); v1.innerHTML = data.sections['cart-drawer'];
        var drawer = document.querySelector('cart-drawer'); var fresh = v1.querySelector('cart-drawer');
        if (drawer && fresh) drawer.outerHTML = fresh.outerHTML; v1.remove();
      }
    } catch (_) {}
    try {
      if (data.sections['cart-icon-bubble'] && document.getElementById('cart-icon-bubble')) {
        var v2 = document.createElement('div'); v2.innerHTML = data.sections['cart-icon-bubble'];
        var bubble = document.getElementById('cart-icon-bubble');
        var freshB = v2.querySelector('#cart-icon-bubble') || v2.firstElementChild;
        if (bubble && freshB) bubble.innerHTML = freshB.innerHTML; v2.remove();
      }
    } catch (_) {}
  }
  function openCartDrawer() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) { try { bubble.dispatchEvent(new Event('click')); } catch (_) {} }
  }
  function flashStatus(text) { if (elAtcStatus) elAtcStatus.textContent = text || ''; }
  // Photo-upload messages: a toast the customer will actually see, plus the
  // status line for errors so the reason is still there after the toast goes.
  function uploadNotice(text, kind) {
    if (kind === 'error') flashStatus(text); else if (kind === 'busy') flashStatus('');
    if (window.PFCPhotoSource && window.PFCPhotoSource.notice) window.PFCPhotoSource.notice(text, kind);
  }

  function cryptoRandom() {
    try {
      var arr = new Uint8Array(16); crypto.getRandomValues(arr);
      return Array.from(arr).map(function (b) { return b.toString(16).padStart(2, '0'); }).join('');
    } catch (_) { return String(Date.now()) + Math.random().toString(16).slice(2); }
  }

  /* ---------- Frame + mount add-ons (print-first, absorbed) ---------- */
  var ADD = (cfg.addons && cfg.addons.enabled) ? cfg.addons : null;

  function addonsEnabled() { return !!(ADD && elAddons); }
  // A mount-up size is too small to frame bare, but mounts INTO a larger frame
  // size (mountUp suffix). frameSuffix is blank for these; the add-on suffix is
  // the outer mountUp size, and a mount is REQUIRED before a frame is allowed.
  function isMountUpSize() {
    var v = state.variant;
    return !!(v && !v.isCustom && !v.frameSuffix && v.mountUp);
  }
  // Custom sizes have no mountUp preset, so the same rule is applied by size: a
  // print under FRAME_MIN_MM on its short side is framed only with a mount, and
  // only once print + mount reaches that size (PFC-UK-1338605: a bare-framed
  // 200×123mm custom print got through).
  var FRAME_MIN_MM = Number(cfg.frameMinMm) || 150;
  function isCustomTooSmallToFrame() {
    return isCustomActive() && Math.min(state.customW || 0, state.customH || 0) < FRAME_MIN_MM;
  }
  function needsMountToFrame() { return isMountUpSize() || isCustomTooSmallToFrame(); }
  // The size suffix the add-ons price at. Normal framable sizes use their own
  // suffix; mount-up sizes price the frame + mount at the outer (mountUp) size.
  function currentSuffix() {
    var v = state.variant;
    if (!v || v.isCustom) return '';
    return v.frameSuffix || v.mountUp || '';
  }
  // The add-on block is offered (visible) on any framable OR mount-up size, and
  // on a custom size once valid dimensions are entered (bespoke-priced).
  function addonCapable() {
    var v = state.variant;
    if (!addonsEnabled() || !v) return false;
    if (v.isCustom) return state.customW > 0 && state.customH > 0;
    return !!(v.frameSuffix || v.mountUp);
  }
  // Outer board dims (mm) the preview frames at — print dims for normal sizes,
  // the larger mountUp board for mount-up sizes. Oriented like the print.
  function outerDimsMm() {
    var v = state.variant;
    if (isMountUpSize() && v.mountUpW) {
      var bw = v.mountUpW, bh = v.mountUpH;
      if (bw === bh) return { w: bw, h: bh };
      var land = state.orientation === 'landscape';
      return { w: land ? Math.max(bw, bh) : Math.min(bw, bh),
               h: land ? Math.min(bw, bh) : Math.max(bw, bh) };
    }
    return printDimsMm(v);
  }
  function frameByCode(code) {
    if (!ADD) return null;
    return ADD.frames.find(function (f) { return f.code === code; }) || null;
  }
  function mountTierCfg() { return ADD && ADD.mounts && ADD.mounts[state.addon.tier]; }

  /* ----- Custom-size bespoke frame/mount pricing -----
   * Catalogue frames/mounts are priced per stocked size. A custom size has no
   * stocked variant, so we derive a price from each item's OWN catalogue prices:
   * fit a line frame: price = m·perimeter + c  /  mount: price = m·area + c
   * over its stocked sizes, evaluate at the custom dims, then apply a bespoke
   * labour multiplier (custom cuts cost more than a stock size). Floored so a
   * tiny size never prices daft-low. Round-up to a ladder bucket still applies. */
  var SUFFIX_MM = {
    'M-A4': [210, 297], 'M-A3': [297, 420], 'M-A2': [420, 594], 'M-A1': [594, 841],
    'I-8X10': [203, 254], 'I-11X14': [279, 356], 'I-12X16': [305, 406], 'I-16X20': [406, 508]
  };
  var CUSTOM_FRAME_MULT = Number(cfg.customFrameMult) || 1.15;
  var CUSTOM_MOUNT_MULT = Number(cfg.customMountMult) || 1.15;
  function fitLinear(pts) {
    var n = pts.length;
    if (!n) return null;
    if (n === 1) return { m: pts[0].y / (pts[0].x || 1), c: 0 };
    var sx = 0, sy = 0, sxx = 0, sxy = 0;
    pts.forEach(function (p) { sx += p.x; sy += p.y; sxx += p.x * p.x; sxy += p.x * p.y; });
    var den = n * sxx - sx * sx;
    if (Math.abs(den) < 1e-9) return { m: sy / (sx || 1), c: 0 };
    var m = (n * sxy - sx * sy) / den;
    return { m: m, c: (sy - m * sx) / n };
  }
  function custDims() { return { w: state.customW || 0, h: state.customH || 0 }; }
  // Current print dims (mm, oriented) — handles preset + custom transparently.
  function printDimsCurrent() { return printDimsMm(state.variant); }
  // Mount/float border each side (mm). Float owns its surround; otherwise the
  // customer-chosen mount border (0 when neither, i.e. a frame hugging the print).
  function addonBorderMm() {
    if (state.addon.frameOn && state.addon.framing === 'float') return FLOAT_GAP_MM;
    if (state.addon.mountOn) return Math.max(0, Number(state.addon.borderMm) || 0);
    return 0;
  }
  // Finished OUTER size (mm) = print + 2×border. Frame + mount are priced and
  // drawn at THIS size — the real framing geometry (mount adds a border, frame
  // grows to fit it), not the print's nominal size.
  function addonOuterMm() {
    var d = printDimsCurrent(), b = addonBorderMm();
    return { w: d.w + 2 * b, h: d.h + 2 * b };
  }
  // Live "Finished size … (incl. 50mm mount border)" badge under the add-ons.
  function updateSizeNote() {
    if (!elAddonSize) return;
    var b = addonBorderMm();
    if (typeof addonActive === 'function' && addonActive() && b > 0) {
      var o = addonOuterMm();
      elAddonSize.hidden = false;
      elAddonSize.textContent = 'Finished size ' + fmtPairDisp(o.w, o.h)
        + ' (incl. ' + fmtDimDisp(b) + ' ' + (state.addon.framing === 'float' ? 'float surround' : 'mount border') + ')';
    } else {
      elAddonSize.hidden = true;
    }
  }
  // Frame + mount summary chips next to "Print 210×297mm · Fine-art giclée".
  function updateAddonChips() {
    var active = (typeof addonActive === 'function') && addonActive();
    if (elFrameChip) {
      if (active && state.addon.frameOn) {
        var f = frameByCode(state.addon.frameCode);
        var label = f ? f.name : 'Frame';
        if (state.addon.framing === 'float') label += ' · Float';
        else if (state.addon.framing === 'gallery') label += ' · Gallery';
        elFrameChip.hidden = false;
        elFrameChip.textContent = 'Frame · ' + label;
      } else { elFrameChip.hidden = true; }
    }
    if (elMountChip) {
      if (active && state.addon.mountOn) {
        var t = mountTierCfg();
        var detail = state.addon.pattern
          ? (state.addon.patternLabel || 'Patterned')
          : (state.addon.colour || 'White');
        elMountChip.hidden = false;
        elMountChip.textContent = 'Mount · ' + (t && t.label ? t.label : 'Standard') + ' ' + detail
          + ' · ' + fmtDimDisp(addonBorderMm());
      } else { elMountChip.hidden = true; }
    }
  }
  // Selected-moulding detail under the frame grid: name · family · W×D mm.
  function updateFrameDetail() {
    if (!elFrameDetail) return;
    var f = frameByCode(state.addon.frameCode);
    if (state.addon.frameOn && f) {
      var w = Number(f.widthMm) || 0, d = Number(f.depthMm) || 0;
      elFrameDetail.hidden = false;
      elFrameDetail.innerHTML = '';
      var nm = document.createElement('strong'); nm.textContent = f.name;
      elFrameDetail.appendChild(nm);
      if (f.family) elFrameDetail.appendChild(document.createTextNode(' · ' + f.family));
      var dims = [];
      if (w) dims.push(fmtMouldDisp(w) + ' wide');
      if (d) dims.push(fmtMouldDisp(d) + ' deep');
      if (dims.length) {
        var dm = document.createElement('span'); dm.className = 'pfc-print__frame-dims';
        dm.textContent = ' · ' + dims.join(' · ');
        elFrameDetail.appendChild(dm);
      }
    } else { elFrameDetail.hidden = true; }
  }
  // Reflect the active border on the preset chips (custom mm = no chip pressed).
  function syncBorderUI() {
    if (!elMountBorders) return;
    Array.from(elMountBorders.children).forEach(function (b) {
      b.setAttribute('aria-pressed', String(Number(b.dataset.border) === Number(state.addon.borderMm)));
    });
  }
  function modelCents(sizes, xOf, mult) {
    var pts = [], minP = Infinity;
    Object.keys(sizes || {}).forEach(function (suf) {
      var mm = SUFFIX_MM[suf]; if (!mm) return;
      var pr = Number(sizes[suf].price);
      pts.push({ x: xOf(mm[0], mm[1]), y: pr });
      if (pr < minP) minP = pr;
    });
    return { pts: pts, minP: minP === Infinity ? 0 : minP, mult: mult };
  }
  function evalModel(model, x) {
    var fit = fitLinear(model.pts);
    if (!fit || !x) return 0;
    var val = fit.m * x + fit.c;
    if (!isFinite(val) || val <= 0) val = model.minP;
    val = Math.max(val, model.minP * 0.6);
    return Math.round(val * model.mult);
  }
  // Frame price (cents) for a given frame, at the current OUTER size. A plain
  // stocked frame (preset print, no mount, standard framing → outer = nominal
  // size) keeps the exact catalogue price the merchant set. Any other config
  // (mount border, float surround, custom size → non-stocked outer) is a bespoke
  // cut: priced from the moulding's own perimeter→price model × bespoke labour.
  function frameCentsCore(f) {
    if (!f) return 0;
    if (!isCustomActive() && !state.addon.mountOn && state.addon.framing === 'standard') {
      var suf = currentSuffix();
      var s = f.sizes && f.sizes[suf];
      if (s) return Number(s.price);
    }
    var o = addonOuterMm();
    return evalModel(modelCents(f.sizes, function (w, h) { return 2 * (w + h); }, CUSTOM_FRAME_MULT), 2 * (o.w + o.h));
  }
  // Mount price (cents) at the current OUTER board area, from the SHARED model
  // (assets/pfc-mount-pricing-core.js) — the same function that generates every
  // catalogue ladder. A mount here is an add-on to a print, so the print line
  // carries the order's postage and this line carries the adhering labour.
  //
  // Superseded: a runtime least-squares fit over 8 catalogue prices. It invented
  // intercepts nobody chose (£3.63 standard / £14.80 premium) and priced a
  // premium print add-on ABOVE buying the same mount standalone.
  function pricingCore() { return window.PFCMountPricing || null; }
  function shopCurrency() { return cfg.shopCurrency || (CP.usd ? 'USD' : 'GBP'); }
  function mountCentsFor(tierKey) {
    var core = pricingCore(); if (!core) return 0;
    var o = addonOuterMm(); if (!o.w || !o.h) return 0;
    return Math.round(core.mountPrice(shopCurrency(), o.w, o.h,
      tierKey === 'premium' ? 'premium' : 'standard', 'mount+photo') * 100);
  }
  function mountCentsCore() {
    var t = mountTierCfg(); if (!t) return 0;
    return mountCentsFor(state.addon.tier);
  }
  // Mount price (cents) for an explicit tier at the current outer board size —
  // used to show the plain↔patterned uplift on each swatch.
  function mountTierPriceCents(tierKey) {
    var t = ADD && ADD.mounts && ADD.mounts[tierKey]; if (!t) return 0;
    return mountCentsFor(tierKey);
  }
  function patternedUpliftCents() {
    return Math.max(0, mountTierPriceCents('premium') - mountTierPriceCents('standard'));
  }
  // Per-swatch price labels (mirrors pfc-mount.js updateColourPrices): the delta
  // is shown RELATIVE to the current selection — a patterned board reads + uplift
  // from a plain one, and plain boards read − uplift when a pattern is selected.
  // Printed text/logo already forces the premium tier, so then no swatch moves.
  function updateMountOptPricesP() {
    if (!elMountColours) return;
    var up = isPersActive() ? 0 : patternedUpliftCents();   // cents
    var selPat = !!state.addon.pattern;
    Array.from(elMountColours.children).forEach(function (b) {
      var ps = b.querySelector('.pfc-moulding__mount-price'); if (!ps) return;
      if (up <= 0) { ps.textContent = ''; return; }
      var thisPat = (b.dataset.pattern != null);
      var delta = up * ((thisPat ? 1 : 0) - (selPat ? 1 : 0));
      if (Math.abs(delta) < 0.5)  ps.textContent = '+ ' + formatMoney(0);
      else if (delta > 0)         ps.textContent = '+ ' + formatMoney(Math.round(delta));
      else                        ps.textContent = '− ' + formatMoney(Math.round(-delta));
    });
  }

  /* ---------- Printed personalisation (text/logo on the mount border) ---------- */
  // Ported from pfc-mount.js; the personalisation rides on the mount add-on,
  // draws in the print's bottom mount border, and forces the Premium tier
  // (Decision A: printed text/logo = premium). Only available when a mount is on.
  function persConfig() { return cfg.personalisation || {}; }
  // Availability is the section's flag alone. It used to ALSO require
  // `persConfig().zones` (variants of the Print Personalisation product), which
  // vanished whenever that product left the Online Store channel — killing the
  // panel silently. Zone prices were never read: the uplift is the premium tier
  // (patternedUplift), so the extra condition only ever broke things.
  function persAvailable() { return !!persConfig().available; }
  function persHasText() { return !!((state.pers.heading && state.pers.heading.trim()) || (state.pers.line2 && state.pers.line2.trim())); }
  function persHasLogo() { return !!(state.pers.logoOn && state.pers.logoImg); }
  function persHasContent() { return persHasText() || persHasLogo(); }
  function isPersActive() { return state.pers.on && state.addon.mountOn && persAvailable() && persHasContent() && persFits(); }

  /* ---------- Narrow-border guard (mirrors pfc-mount.js) ----------
     The printed line sits in the bottom mount border minus the rebate-safe edge
     inset and the bevel gap, so a thin border leaves nothing to print on: at the
     MOUNT_BORDER_MIN of 15mm the band is 15 − 12 − 3 = 0 and every draw call was
     silently skipped — the customer typed text and saw none. Block the add-on
     with a reason instead. Threshold is in mm; the old `> 8` test was canvas px,
     so the same border passed or failed depending on viewport size. */
  var PERS_MIN_BAND_MM = 14;   // ≈4mm cap height once the 3mm box pad comes off
  function persBandMm() {
    if (!state.addon.mountOn) return 0;
    var b = addonBorderMm();
    return b > 0 ? b - PERS_EDGE_MM - PERS_GAP_MM : 0;
  }
  function persFits() { return persBandMm() >= PERS_MIN_BAND_MM; }
  function persMinBorderMm() { return Math.ceil(PERS_MIN_BAND_MM + PERS_EDGE_MM + PERS_GAP_MM); }
  function persFitMessage() {
    return 'Printed text needs a mount border of at least ' + persMinBorderMm()
      + 'mm — this one is ' + Math.round(addonBorderMm()) + 'mm. Widen the border to add text.';
  }
  // Disable the add-on (and say why) whenever the mount border is too narrow.
  function updatePersFit() {
    var fits = persFits();
    if (elPersToggle) elPersToggle.disabled = !fits;
    if (elPersWrap) elPersWrap.classList.toggle('is-blocked', !fits);
    if (elPersPanel) elPersPanel.hidden = !fits || !state.pers.on;
    if (elPersFitNote) {
      elPersFitNote.hidden = fits;
      if (!fits) elPersFitNote.textContent = persFitMessage();
    }
  }
  // The mount's base board colour (the personalisation sits on / is cleared over).
  function printMountBaseHex() {
    if (state.addon.pattern) return (ADD && ADD.stripeBaseHex) || '#fafaf6';
    return (state.addon.colour === 'Black') ? '#1a1a1a' : '#fafaf6';
  }
  function fontFamilyCssP(name) { return '"' + name + '", ' + UI_FONT; }
  function persInk() {
    var hex = printMountBaseHex().replace('#', '');
    if (hex.length === 3) hex = hex.split('').map(function (c) { return c + c; }).join('');
    var r = parseInt(hex.substr(0, 2), 16), g = parseInt(hex.substr(2, 2), 16), b = parseInt(hex.substr(4, 2), 16);
    return ((0.299 * r + 0.587 * g + 0.114 * b) / 255) > 0.55 ? '#1a1a1a' : '#ffffff';
  }
  function drawLogoFitP(ctx, img, x, y, w, h, align) {
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height; if (!iw || !ih) return;
    var s = Math.min(w / iw, h / ih), dw = iw * s, dh = ih * s;
    var dx = align === 'left' ? x : align === 'right' ? (x + w - dw) : (x + (w - dw) / 2);
    ctx.drawImage(img, dx, y + (h - dh) / 2, dw, dh);
  }
  // Personalisation text size (physical heading em mm by S/M/L) + rebate-safe
  // geometry — mirrors pfc-mount.js so the printed text matches across customisers.
  var PERS_CAP_MM = { xs: 3.5, s: 5, m: 7, l: 9 };
  // Fit-by-space (assets/pfc-pers-fit-core.js): the chosen size prints exactly,
  // the text zone is the print (opening) width, and the room left is what
  // varies. Off unless the theme setting pers_fit_v2 is on or the URL has
  // ?pers_fit=1 — when off, pf() is a stub and every path behaves as before.
  var PF = window.PFCPersFit || null;
  var persFit = null;
  // A function declaration, so it works during the first render — which runs
  // before this part of the file has executed (a `var` stub would be undefined).
  function pf() {
    return persFit || pf.stub || (pf.stub = {
      enabled: false, update: function () {}, addError: function () { return null; }, exact: function () { return false; }
    });
  }
  // Text zone in mm ({w, h}) for the current mount, or null when there is none.
  function persZoneMm() {
    if (!PF || !state.addon.mountOn) return null;
    var o = addonOuterMm(), b = addonBorderMm();
    if (!o || !o.w) return null;
    var band = persBandMm(); if (band <= 0) return null;
    return { w: PF.zoneWidthMm(o.w - 2 * b, o.w, PERS_EDGE_MM, PERS_BOXPAD_MM),
             h: PF.textZoneHeightMm(band, PERS_BOXPAD_MM, persHasLogo()) };
  }
  // The band the text is drawn in, in canvas px. Legacy: the full board width
  // inside the rebate-safe edge. Fit-by-space: centred, as wide as the print.
  function persRect(boardLeft, boardWpx, top, bottom, pxPerMm) {
    var edge = PERS_EDGE_MM * pxPerMm;
    var z = pf().enabled ? persZoneMm() : null;
    if (!z) return { x: boardLeft + edge, y: top, w: boardWpx - edge * 2, h: bottom - top };
    var pad = PERS_BOXPAD_MM * pxPerMm, zw = z.w * pxPerMm;
    var ins = PF.alignInsetMm(persMeasureCtx(), fontFamilyCssP(state.pers.font),
      [state.pers.heading, state.pers.line2], persCapMmP(), state.pers.align || 'center');
    return { x: boardLeft + (boardWpx - zw) / 2 - pad + ins.l * pxPerMm, y: top,
             w: zw + pad * 2 - (ins.l + ins.r) * pxPerMm, h: bottom - top };
  }
  // Vector text spec for the print-file app (fit-by-space, text-only designs):
  // the same shape pfc-moulding.js sends, so the print re-renders at the exact
  // chosen size instead of being re-fitted from the PNG.
  var lastPersRenderSpec = null;
  function persCapMmP() { return PERS_CAP_MM[state.pers.size] || PERS_CAP_MM.m; }
  var PERS_EDGE_MM = 12, PERS_GAP_MM = 3, PERS_BOXPAD_MM = 3;
  function persMeasureCtx() { persMeasureCtx._c = persMeasureCtx._c || document.createElement('canvas').getContext('2d'); return persMeasureCtx._c; }
  function persStepFitPx(zoneW, zoneH, capPx) {
    var lines = [state.pers.heading, state.pers.line2].filter(function (t) { return t && t.trim(); });
    var n = lines.length || 1, fam = fontFamilyCssP(state.pers.font);
    var size = Math.min((zoneH / (n + 0.4)) * 0.74, capPx, zoneH / (1.32 * n));
    var ctx = persMeasureCtx();
    lines.forEach(function (t) { var s = size; ctx.font = '600 ' + s + 'px ' + fam; while (ctx.measureText(t).width > zoneW && s > 6) { s -= 1; ctx.font = '600 ' + s + 'px ' + fam; } if (s < size) size = s; });
    return Math.max(6, size);
  }
  function syncPersSizeSteps(zoneW, zoneH, pxPerMm) {
    if (pf().enabled) { pf().update(); return; }
    if (!elPersSizeBtns.length) return;
    if (!persHasText() || !zoneW || !zoneH) {
      if (elPersSizeGroup) elPersSizeGroup.hidden = false;
      if (elPersSizeNote) elPersSizeNote.hidden = true;
      elPersSizeBtns.forEach(function (b) { b.disabled = false; b.setAttribute('aria-pressed', b.dataset.persSize === state.pers.size ? 'true' : 'false'); });
      return;
    }
    var keys = ['s', 'm', 'l'], eff = {};
    keys.forEach(function (k) { eff[k] = Math.round(persStepFitPx(zoneW, zoneH, PERS_CAP_MM[k] * pxPerMm)); });
    var allSame = (eff.s === eff.m && eff.m === eff.l);
    if (elPersSizeGroup) elPersSizeGroup.hidden = allSame;
    if (elPersSizeNote) elPersSizeNote.hidden = !allSame;
    if (allSame) return;
    var prevEff = null;
    keys.forEach(function (k) {
      var btn = elPersSizeBtns.find(function (b) { return b.dataset.persSize === k; });
      if (!btn) return;
      btn.disabled = (prevEff !== null && eff[k] <= prevEff);
      btn.setAttribute('aria-pressed', k === state.pers.size ? 'true' : 'false');
      prevEff = eff[k];
    });
  }
  // The on-page canvas inherits the page's CSS letter-spacing (0.6px), which
  // canvas text honours — so the preview drew every line wider than the print
  // file (off-screen canvases have none). Mount text is always drawn unspaced.
  function drawTextBlockP(ctx, lines, x, y, w, h, align, ink, capPx) {
    lines = lines.filter(function (t) { return t && t.trim(); });
    if (!lines.length) return;
    if ('letterSpacing' in ctx) ctx.letterSpacing = '0px';
    var fam = fontFamilyCssP(state.pers.font), n = lines.length, lineH = h / (n + 0.4), base = lineH * 0.74;
    if (capPx) base = Math.min(base, capPx);   // cap to the chosen physical mm size
    var size = base;
    lines.forEach(function (t) {
      if (pf().exact()) return;   // fit-by-space: the chosen size is what prints
      var s = base; ctx.font = '600 ' + s + 'px ' + fam;
      while (ctx.measureText(t).width > w && s > 6) { s -= 1; ctx.font = '600 ' + s + 'px ' + fam; }
      if (s < size) size = s;
    });
    ctx.font = '600 ' + size + 'px ' + fam;
    ctx.fillStyle = ink; ctx.textAlign = align;
    // Centre each line on the font's own ascent/descent, NOT textBaseline
    // 'middle': Chrome and the print-file app (node-canvas) disagree on where
    // 'middle' is (~0.8 mm at M), but agree exactly on these metrics — and this
    // is where the print app has always put the line.
    ctx.textBaseline = 'alphabetic';
    var fm = ctx.measureText('Hxg');
    var asc = fm.fontBoundingBoxAscent != null ? fm.fontBoundingBoxAscent : (fm.emHeightAscent != null ? fm.emHeightAscent : size * 0.8);
    var desc = fm.fontBoundingBoxDescent != null ? fm.fontBoundingBoxDescent : (fm.emHeightDescent != null ? fm.emHeightDescent : size * 0.2);
    var mid = (asc - desc) / 2;
    var tx = align === 'left' ? x : align === 'right' ? (x + w) : (x + w / 2);
    var lh = size * 1.32;
    var startY = y + (h - lh * n) / 2 + lh / 2;
    lines.forEach(function (t, i) { ctx.fillText(t, tx, startY + i * lh + mid); });
  }
  function persLogoRectP(x, y, w, h, align) {
    var logo = state.pers.logoImg; if (!logo) return null;
    var iw = logo.naturalWidth || logo.width, ih = logo.naturalHeight || logo.height; if (!iw || !ih) return null;
    var s = Math.min(w / iw, h / ih), dw = iw * s, dh = ih * s;
    var dx = align === 'left' ? x : align === 'right' ? (x + w - dw) : (x + (w - dw) / 2);
    return { x: dx, y: y + (h - dh) / 2, w: dw, h: dh };
  }
  function persTextRectP(ctx, x, y, w, h, align, capPx) {
    var ls = [state.pers.heading, state.pers.line2].filter(function (t) { return t && t.trim(); });
    if (!ls.length) return null;
    var prevLs = ctx.letterSpacing;
    if ('letterSpacing' in ctx) ctx.letterSpacing = '0px';
    var fam = fontFamilyCssP(state.pers.font), n = ls.length, lineH = h / (n + 0.4), base = lineH * 0.74, size = base;
    if (capPx) base = size = Math.min(base, capPx);
    ls.forEach(function (t) { if (pf().exact()) return; var s = base; ctx.font = '600 ' + s + 'px ' + fam; while (ctx.measureText(t).width > w && s > 6) { s -= 1; ctx.font = '600 ' + s + 'px ' + fam; } if (s < size) size = s; });
    ctx.font = '600 ' + size + 'px ' + fam;
    var tw = 0; ls.forEach(function (t) { tw = Math.max(tw, ctx.measureText(t).width); });
    var tl = align === 'left' ? x : align === 'right' ? (x + w - tw) : (x + (w - tw) / 2);
    var lh = size * 1.32;
    var startY = y + (h - lh * n) / 2 + lh / 2;
    if ('letterSpacing' in ctx) ctx.letterSpacing = prevLs;
    return { x: tl, y: startY - size / 2, w: tw, h: (n - 1) * lh + size };
  }
  function persUnionP(a, b) {
    if (!a) return b; if (!b) return a;
    var x1 = Math.min(a.x, b.x), y1 = Math.min(a.y, b.y), x2 = Math.max(a.x + a.w, b.x + b.w), y2 = Math.max(a.y + a.h, b.y + b.h);
    return { x: x1, y: y1, w: x2 - x1, h: y2 - y1 };
  }
  function drawPersonalisationP(ctx, rect, ink, capPx, boxPadPx) {
    var align = state.pers.align || 'center', lines = [state.pers.heading, state.pers.line2];
    var hasText = persHasText(), hasLogo = persHasLogo();
    if (!hasText && !hasLogo) return;
    var pad = boxPadPx || Math.min(rect.w, rect.h) * 0.10;
    var inner = { x: rect.x + pad, y: rect.y + pad, w: rect.w - pad * 2, h: rect.h - pad * 2 };
    if (inner.w <= 4 || inner.h <= 4) inner = { x: rect.x, y: rect.y, w: rect.w, h: rect.h };
    var logoZone = null, textZone = null;
    if (hasText && hasLogo) {
      var gap = inner.h * 0.06, logoH = inner.h * 0.42, textH = inner.h - logoH - gap;
      if (state.pers.logoPos === 'below') {
        textZone = { x: inner.x, y: inner.y, w: inner.w, h: textH };
        logoZone = { x: inner.x, y: inner.y + textH + gap, w: inner.w, h: logoH };
      } else {
        logoZone = { x: inner.x, y: inner.y, w: inner.w, h: logoH };
        textZone = { x: inner.x, y: inner.y + logoH + gap, w: inner.w, h: textH };
      }
    } else if (hasText) { textZone = inner; } else {
      var lh = inner.h * 0.58;
      logoZone = { x: inner.x, y: inner.y + (inner.h - lh) / 2, w: inner.w, h: lh };
    }
    // White backing box only over a patterned board (keeps text legible).
    if (state.addon.pattern) {
      var bb = null;
      if (logoZone) bb = persUnionP(bb, persLogoRectP(logoZone.x, logoZone.y, logoZone.w, logoZone.h, align));
      if (textZone) bb = persUnionP(bb, persTextRectP(ctx, textZone.x, textZone.y, textZone.w, textZone.h, align, capPx));
      if (bb && bb.w > 0 && bb.h > 0) {
        var bx = Math.max(rect.x, bb.x - pad), by = Math.max(rect.y, bb.y - pad);
        var bw = Math.min(rect.x + rect.w, bb.x + bb.w + pad) - bx;
        var bh = Math.min(rect.y + rect.h, bb.y + bb.h + pad) - by;
        var br = Math.min(bw, bh) * 0.2;
        ctx.save(); ctx.beginPath();
        if (ctx.roundRect) { ctx.roundRect(bx, by, bw, bh, br); } else { ctx.rect(bx, by, bw, bh); }
        ctx.fillStyle = printMountBaseHex(); ctx.fill(); ctx.restore();
      }
      ink = persInk();
    }
    ctx.save();
    if (logoZone && state.pers.logoImg) drawLogoFitP(ctx, state.pers.logoImg, logoZone.x, logoZone.y, logoZone.w, logoZone.h, align);
    if (textZone) drawTextBlockP(ctx, lines, textZone.x, textZone.y, textZone.w, textZone.h, align, ink, capPx);
    ctx.restore();
  }
  // High-res transparent PNG of the personalisation at the mount-outer aspect,
  // placed in the bottom border (mirrors the preview).
  function renderPersExportP() {
    lastPersRenderSpec = null;
    var o = addonOuterMm(); if (!o || !o.w || !o.h) return null;
    var border = addonBorderMm();
    var s = 2000 / o.w, W = Math.round(o.w * s), H = Math.round(o.h * s);
    var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    var ctx = cv.getContext('2d');
    // Match the mount customiser's export geometry (pfc-mount.js renderPersExport)
    // so the printed text size is consistent with the on-screen preview + the
    // mount product.
    var bpx = border * s;
    var edge = PERS_EDGE_MM * s, gap = PERS_GAP_MM * s;
    var apBottom = H - bpx;
    var bandTop = apBottom + gap, bandBot = H - edge;
    var rect = persRect(0, W, bandTop, bandBot, s);
    if (rect.h < 8) return null;
    drawPersonalisationP(ctx, rect, persInk(), persCapMmP() * s, PERS_BOXPAD_MM * s);
    var r1 = function (n) { return Math.round(n * 10) / 10; };
    // Sent for fit-by-space designs, and ALWAYS for a logo design (the logo
    // can only reach the print file this way).
    lastPersRenderSpec = (pf().enabled || persHasLogo()) ? {
      v: 1,
      lines: [state.pers.heading, state.pers.line2],
      font: state.pers.font,
      align: state.pers.align || 'center',
      capMm: persCapMmP(),
      exact: pf().enabled || undefined,
      inkHex: persInk(),
      boardWmm: r1(o.w), boardHmm: r1(o.h),
      bandMm: { x: r1(rect.x / s), y: r1(rect.y / s), w: r1(rect.w / s), h: r1(rect.h / s) },
      boxPadMm: PERS_BOXPAD_MM,
      patterned: !!state.addon.pattern,
      mountBaseHex: printMountBaseHex()
    } : null;
    return cv.toDataURL('image/png');
  }
  // Uploads the rendered overlay and, for a logo design, the ORIGINAL logo file:
  // the print-file app redraws the logo from it (the overlay is screen-res), and
  // without it every logo was dropped from the print file.
  function uploadPersImageP(dataUrl) {
    var key = uploadKey('personalisation.png');
    var jobs = [uploadOne(dataUrl, key)];
    var logoKey = null;
    if (persHasLogo() && state.pers.logoDataUrl) {
      logoKey = uploadKey('personalisation-logo' + (/^data:image\/png/i.test(state.pers.logoDataUrl) ? '.png' : '.jpg'));
      jobs.push(uploadOne(state.pers.logoDataUrl, logoKey));
    }
    return Promise.all(jobs).then(function () {
      var logoUrl = logoKey ? publicS3Url(logoKey) : null;
      if (logoUrl && lastPersRenderSpec) lastPersRenderSpec.logo = { url: logoUrl, pos: state.pers.logoPos || 'above' };
      return { url: publicS3Url(key), logoUrl: logoUrl };
    });
  }
  function loadPersLogoFileP(file) {
    if (!file) return;
    var reader = new FileReader();
    reader.onload = function (e) {
      state.pers.logoDataUrl = e.target.result;
      var img = new Image();
      img.onload = function () {
        state.pers.logoImg = img;
        if (elPersLogoDrop) elPersLogoDrop.dataset.hasImage = 'true';
        if (elPersLogoThumb) elPersLogoThumb.style.backgroundImage = 'url("' + state.pers.logoDataUrl + '")';
        if (elPersLogoTitle) elPersLogoTitle.textContent = 'Logo added — click to replace';
        refreshAddons(); renderPreview();
      };
      img.src = state.pers.logoDataUrl;
    };
    reader.readAsDataURL(file);
  }
  function setPersFontValueP() {
    if (!elPersFontValue) return;
    elPersFontValue.textContent = state.pers.font;
    elPersFontValue.style.fontFamily = fontFamilyCssP(state.pers.font);
  }
  function renderPersFontsP() {
    if (!elPersFontList) return;
    elPersFontList.innerHTML = '';
    PERS_FONTS.forEach(function (f) {
      var li = document.createElement('li');
      li.className = 'pfc-moulding__select-option';
      li.setAttribute('role', 'option');
      li.dataset.font = f; li.textContent = f;
      li.style.fontFamily = fontFamilyCssP(f);
      li.setAttribute('aria-selected', f === state.pers.font ? 'true' : 'false');
      li.addEventListener('click', function () {
        state.pers.font = f;
        Array.from(elPersFontList.children).forEach(function (o) { o.setAttribute('aria-selected', o.dataset.font === f ? 'true' : 'false'); });
        setPersFontValueP(); setPersFontOpenP(false); renderPreview();
      });
      elPersFontList.appendChild(li);
    });
    setPersFontValueP();
  }
  function setPersFontOpenP(open) {
    if (!elPersFontList || !elPersFontTrigger) return;
    elPersFontList.hidden = !open;
    elPersFontTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (elPersFontSelect) elPersFontSelect.classList.toggle('is-open', open);
  }
  function updateLogoFieldsP() { if (elPersLogoFields) elPersLogoFields.hidden = !state.pers.logoOn; }
  function updatePersPriceP() {
    if (!elPersPrice) return;
    // Pers prices at the Premium mount tier. If a pattern is already chosen the
    // board is premium-priced, so it's included; otherwise show the uplift.
    if (state.addon.pattern) { elPersPrice.textContent = 'included'; return; }
    var std = (ADD && ADD.mounts && ADD.mounts.standard) || null;
    var prem = (ADD && ADD.mounts && ADD.mounts.premium) || null;
    var o = addonOuterMm();
    if (!std || !prem || !o) { elPersPrice.textContent = ''; return; }
    // Premium uplift from the SHARED model — same source as the mount price
    // itself, so the "+ £x" hint can never disagree with what's charged.
    var up = mountCentsFor('premium') - mountCentsFor('standard');
    elPersPrice.textContent = up > 0 ? ('+ ' + formatMoney(up)) : '';
  }
  function loadPersFontsP() {
    if (!document.fonts || !document.fonts.load) return;
    PERS_FONTS.forEach(function (f) { try { document.fonts.load('600 32px "' + f + '"'); } catch (_) {} });
    if (document.fonts.ready) document.fonts.ready.then(function () { renderPreview(); });
  }

  /* ----- Framing style (depth-driven) -----
   * Mirrors the moulding customiser: deep box mouldings (depth ≥ DEEP_MM) frame
   * as Gallery or Float only — no Standard; shallow mouldings frame Standard.
   * Gallery is visually identical to Standard front-on (the spacer is hidden);
   * Float makes the print float on a white board with a surround gap. */
  var DEEP_MM = Number(cfg.deepFrameMm) || 30;
  var FLOAT_GAP_MM = Number(cfg.floatGapMm) || 20;
  // Mount border presets (mm each side) + sane custom-mm bounds.
  var MOUNT_BORDER_STEPS = (Array.isArray(cfg.mountBorderSteps) && cfg.mountBorderSteps.length) ? cfg.mountBorderSteps : [30, 50, 80];
  var MOUNT_BORDER_MIN = Number(cfg.mountBorderMin) || 15;
  var MOUNT_BORDER_MAX = Number(cfg.mountBorderMax) || 150;
  function frameIsDeep() {
    var f = frameByCode(state.addon.frameCode);
    return !!(f && Number(f.depthMm) >= DEEP_MM);
  }
  // Resolve framing for the current frame + sync the picker. Deep → gallery/float
  // (default gallery); shallow → standard (picker hidden). Float owns the
  // surround, so it hides + unticks the separate mount (mirrors the moulding UI).
  function syncFraming() {
    var deep = state.addon.frameOn && frameIsDeep();
    // Float adds its own surround → can't apply to a mount-up size (those are
    // too small to frame without mounting up into a larger board first).
    var floatAllowed = deep && !needsMountToFrame();
    if (deep) {
      if (state.addon.framing !== 'gallery' && state.addon.framing !== 'float') state.addon.framing = 'gallery';
      if (state.addon.framing === 'float' && !floatAllowed) state.addon.framing = 'gallery';
    } else {
      state.addon.framing = 'standard';
    }
    if (elFrameFramingWrap) elFrameFramingWrap.hidden = !deep;
    elFrameFramingBtns.forEach(function (b) {
      if (b.dataset.framing === 'float') b.hidden = !floatAllowed;
      b.setAttribute('aria-pressed', String(b.dataset.framing === state.addon.framing));
    });
    var floatNow = deep && state.addon.framing === 'float';
    var mountLabel = elMountToggle && (elMountToggle.closest('.pfc-extra') || elMountToggle.closest('label'));
    if (floatNow && state.addon.mountOn) {
      state.addon.mountOn = false;
      if (elMountToggle) elMountToggle.checked = false;
      if (elMountPicker) elMountPicker.hidden = true;
    }
    if (mountLabel) mountLabel.hidden = floatNow;
  }
  function framePriceCents() {
    return state.addon.frameOn ? frameCentsCore(frameByCode(state.addon.frameCode)) : 0;
  }
  function mountPriceCents() {
    return state.addon.mountOn ? mountCentsCore() : 0;
  }
  // Add-ons are "active" (route through the ladder) only when enabled, on a
  // framable preset size, with at least one of frame/mount ticked. On a
  // mount-up size a mount is mandatory — a frame alone is not offered.
  function addonActive() {
    if (!addonsEnabled()) return false;
    if (isCustomActive()) {
      if (!(state.customW > 0 && state.customH > 0)) return false;
      if (isCustomTooSmallToFrame()) return !!state.addon.mountOn;
      return state.addon.frameOn || state.addon.mountOn;
    }
    if (!currentSuffix()) return false;
    if (isMountUpSize()) return !!state.addon.mountOn;
    return state.addon.frameOn || state.addon.mountOn;
  }

  /* ----- Composite preview drawing (frame ring + mount + pattern) ----- */
  function patternByKeyP(key) {
    var pats = (ADD && ADD.mountPatterns) || [];
    return pats.find(function (p) { return p.key === key; }) || pats[0] || { type: 'stripes', bands: 19 };
  }
  function stripeBandCountP(boardWmm, pat) {
    if (pat.bands) return pat.bands;
    if (pat.bandWidthMm) return Math.max(6, Math.round((boardWmm || 210) / pat.bandWidthMm));
    return 19;
  }
  // CSS gradient preview for a pattern swatch chip (mirrors pfc-moulding.js
  // patternChipGradient), using the live band colour.
  function printStripeBase() { return (ADD && ADD.stripeBaseHex) || '#fafaf6'; }
  function patternChipGradientP(pat) {
    var a = state.addon.stripeHex || '#23395d', base = printStripeBase();
    if (pat.type === 'checkers') return 'repeating-conic-gradient(' + a + ' 0% 25%, ' + base + ' 0% 50%) 0 / 9px 9px';
    if (pat.type === 'gingham') return 'repeating-linear-gradient(0deg,' + a + ' 0 2px,transparent 2px 7px),repeating-linear-gradient(90deg,' + a + ' 0 2px,transparent 2px 7px),' + base;
    if (pat.type === 'polka') return 'radial-gradient(' + a + ' 30%, transparent 33%) 0 0 / 8px 8px, ' + base;
    if (pat.type === 'chevron') return 'repeating-linear-gradient(135deg,' + a + ' 0 2px,' + base + ' 2px 5px)';
    if (pat.type === 'accent') return 'radial-gradient(closest-side, ' + base + ' 52%, ' + a + ' 55% 74%, ' + base + ' 77%)';
    var u = pat.bandWidthMm ? 2 : 4;
    return 'repeating-linear-gradient(90deg,' + base + ' 0 ' + u + 'px,' + a + ' ' + u + 'px ' + (u * 2) + 'px)';
  }
  function refreshPatternChips() {
    if (!elMountColours) return;
    Array.from(elMountColours.querySelectorAll('[data-pattern]')).forEach(function (b) {
      var pp = (ADD.mountPatterns || []).find(function (x) { return x.key === b.dataset.pattern; });
      var chip = b.querySelector('.pfc-moulding__mount-chip');
      if (pp && chip) chip.style.background = patternChipGradientP(pp);
    });
  }
  // Mirror of pfc-moulding.js drawMountFill (Standard colour / Premium pattern).
  function drawMountFillP(c, x, y, w, h, boardWmm) {
    var a = state.addon;
    if (a.pattern) {
      var pat = patternByKeyP(a.pattern);
      var base = (ADD && ADD.stripeBaseHex) || '#fafaf6';
      var col = a.stripeHex || '#23395d';
      c.fillStyle = base; c.fillRect(x, y, w, h);
      if (pat.type === 'stripes') {
        var n = stripeBandCountP(boardWmm, pat), bw = w / n;
        for (var i = 0; i < n; i++) {
          c.fillStyle = (i % 2 === 0) ? base : col;
          c.fillRect(x + i * bw, y, Math.ceil(bw) + 1, h);
        }
      } else if (pat.type === 'checkers') {
        var pxPerMm = w / (boardWmm || 210);
        var cell = Math.max(6, (pat.checkMm || 15) * pxPerMm);
        var cols = Math.ceil(w / cell), rows = Math.ceil(h / cell);
        c.fillStyle = col;
        for (var ry = 0; ry < rows; ry++) for (var cx = 0; cx < cols; cx++) {
          if ((cx + ry) % 2 === 0) continue;
          c.fillRect(x + cx * cell, y + ry * cell, Math.ceil(cell) + 1, Math.ceil(cell) + 1);
        }
      } else if (pat.type === 'gingham') {
        // Two semi-transparent band passes (V + H); overlaps read darkest.
        var gpx = w / (boardWmm || 210);
        var gcell = Math.max(6, (pat.cellMm || 16) * gpx);
        c.fillStyle = col; c.globalAlpha = 0.42;
        var gcols = Math.ceil(w / gcell), grows = Math.ceil(h / gcell);
        for (var gx = 0; gx < gcols; gx += 2) c.fillRect(x + gx * gcell, y, Math.ceil(gcell) + 1, h);
        for (var gy = 0; gy < grows; gy += 2) c.fillRect(x, y + gy * gcell, w, Math.ceil(gcell) + 1);
        c.globalAlpha = 1;
      } else if (pat.type === 'polka') {
        var ppx = w / (boardWmm || 210);
        var pcell = Math.max(8, (pat.dotMm || 18) * ppx);
        var prd = pcell * 0.3;
        c.fillStyle = col;
        var prows = Math.ceil(h / pcell) + 1, pcols = Math.ceil(w / pcell) + 1;
        for (var pry = 0; pry < prows; pry++) for (var pcx = 0; pcx < pcols; pcx++) {
          var pox = x + pcx * pcell + (pry % 2 ? pcell / 2 : 0) + pcell / 2;
          var poy = y + pry * pcell + pcell / 2;
          c.beginPath(); c.arc(pox, poy, prd, 0, Math.PI * 2); c.fill();
        }
      } else if (pat.type === 'chevron') {
        var cpx = w / (boardWmm || 210);
        var amp = Math.max(5, (pat.bandMm || 14) * cpx);
        c.strokeStyle = col; c.lineWidth = Math.max(2, amp * 0.5); c.lineCap = 'butt';
        for (var cyy = y - h; cyy < y + h * 2; cyy += amp * 2) {
          c.beginPath();
          var up = true;
          for (var cxx = x; cxx <= x + w + amp; cxx += amp) {
            var cpy = cyy + (up ? 0 : amp);
            if (cxx === x) c.moveTo(cxx, cpy); else c.lineTo(cxx, cpy);
            up = !up;
          }
          c.stroke();
        }
      }
      // 'accent' = base board + a keyline ring around the aperture, drawn in
      // renderPreview (not a board fill).
      return;
    }
    c.fillStyle = (a.colour === 'Black') ? '#1a1a1a' : '#fafaf6';
    c.fillRect(x, y, w, h);
  }
  // Texture cache, keyed by moulding code. Mirrors pfc-moulding.js loadTexture:
  // a cache-bust param forces a clean CORS fetch (a non-CORS <img> copy already
  // in the browser cache fails crossOrigin='anonymous' even though S3 sends
  // Access-Control-Allow-Origin:*), and onerror falls through to the painted
  // fallback instead of leaving every frame stuck on the brown default.
  var _texCache = {};
  function getFrameTex() {
    var fr = frameByCode(state.addon.frameCode);
    if (!fr || !fr.texture) return null;
    var key = fr.code || fr.texture;
    if (_texCache[key]) return _texCache[key];
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () { renderPreview(); };
    im.onerror = function () { _texCache[key] = null; };
    im.src = fr.texture + (fr.texture.indexOf('?') === -1 ? '?' : '&') + 'v=1';
    _texCache[key] = im;
    return im;
  }
  // Mitred rails with the moulding texture TILED (not stretched), ported from
  // pfc-moulding.js renderPreview. Each side is a trapezoid (outer corner → next
  // outer corner → matching inner corners); the texture repeats along the rail,
  // scaled so its natural height fills the frame depth (fb), and is rotated so
  // +x runs along the rail and +y goes inner-edge→outward — so the grain runs
  // the right way and the corners mitre. dpr resets the transform after tiling.
  function drawFrameRing(c, ox, oy, tw, th, fb, dpr) {
    var img = getFrameTex();
    var hasTex = !!(img && img.complete && img.naturalWidth > 0);
    var frameColour = '#3a2c1d';
    var ix = ox + fb, iy = oy + fb, iw = tw - fb * 2, ih = th - fb * 2;

    function drawRail(ox1, oy1, ox2, oy2, ix1, iy1, ix2, iy2, gradDir, tx, ty, angle) {
      c.save();
      c.beginPath();
      c.moveTo(ox1, oy1); c.lineTo(ox2, oy2); c.lineTo(ix2, iy2); c.lineTo(ix1, iy1);
      c.closePath();
      c.clip();
      if (hasTex) {
        c.translate(tx, ty);
        c.rotate(angle);
        var sc = fb / img.naturalHeight;          // height fills the frame depth
        c.scale(sc, sc);
        var pat = c.createPattern(img, 'repeat');
        if (pat) {
          c.fillStyle = pat;
          var maxDim = Math.max(tw, th) / sc;
          c.fillRect(-maxDim, -2, maxDim * 3, img.naturalHeight + 4);
        }
        c.setTransform(dpr, 0, 0, dpr, 0, 0);
      } else {
        c.fillStyle = frameColour;
        c.fill();
      }
      // Soft bevel sheen across the rail (kept gentle so light mouldings stay light).
      var grad = (gradDir === 'tb')
        ? c.createLinearGradient(ox1, oy1, ix1, iy1)
        : c.createLinearGradient(ox1, oy1, ox2, oy2);
      grad.addColorStop(0, 'rgba(255,255,255,0.09)');
      grad.addColorStop(0.4, 'rgba(255,255,255,0.02)');
      grad.addColorStop(1, 'rgba(0,0,0,0.10)');
      c.fillStyle = grad;
      c.fill();
      c.restore();
    }

    // Top, Bottom, Left, Right.
    drawRail(ox, oy, ox + tw, oy, ix, iy, ix + iw, iy, 'tb', ox, oy, 0);
    drawRail(ox + tw, oy + th, ox, oy + th, ix + iw, iy + ih, ix, iy + ih, 'tb', ox + tw, oy + th, Math.PI);
    drawRail(ox, oy + th, ox, oy, ix, iy + ih, ix, iy, 'lr', ox, oy + th, -Math.PI / 2);
    drawRail(ox + tw, oy, ox + tw, oy + th, ix + iw, iy, ix + iw, iy + ih, 'lr', ox + tw, oy, Math.PI / 2);

    // Outer edge + inner rabbet shadow for depth.
    c.strokeStyle = 'rgba(0,0,0,0.22)'; c.lineWidth = 1;
    c.strokeRect(ox + 0.5, oy + 0.5, tw - 1, th - 1);
    c.strokeRect(ix + 0.5, iy + 0.5, iw - 1, ih - 1);
  }

  /* ----- Render the pickers (once) ----- */
  function buildAddons() {
    if (!addonsEnabled()) return;
    // Frame swatch grid, grouped by family.
    if (elFrameGrid) {
      elFrameGrid.innerHTML = '';
      var byFam = {};
      ADD.frames.forEach(function (f) { (byFam[f.family || 'Frames'] = byFam[f.family || 'Frames'] || []).push(f); });
      Object.keys(byFam).forEach(function (fam) {
        var grp = document.createElement('div'); grp.className = 'pfc-print__swatch-group';
        var h = document.createElement('p'); h.className = 'pfc-print__swatch-fam'; h.textContent = fam;
        grp.appendChild(h);
        var row = document.createElement('div'); row.className = 'pfc-print__swatch-row';
        byFam[fam].forEach(function (f) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'pfc-print__swatch'; b.dataset.frameCode = f.code;
          var tip = f.name;
          if (Number(f.widthMm)) tip += ' · ' + fmtMouldDisp(Number(f.widthMm)) + ' wide';
          if (Number(f.depthMm)) tip += ' · ' + fmtMouldDisp(Number(f.depthMm)) + ' deep';
          b.title = tip; b.setAttribute('aria-label', tip);
          if (f.image) { var im = document.createElement('img'); im.src = f.image; im.alt = f.name; im.loading = 'lazy'; b.appendChild(im); }
          else { b.textContent = f.name; }
          b.addEventListener('click', function () { selectFrame(f.code); });
          row.appendChild(b);
        });
        grp.appendChild(row); elFrameGrid.appendChild(grp);
      });
    }
    // Mount board — one grid, plain colours + patterns together (no tier toggle).
    // Picking a plain colour = standard price; a pattern = premium price (tier is
    // derived in setTierFromState, not chosen by the customer).
    if (elMountColours) {
      elMountColours.innerHTML = '';
      (ADD.mountColours || ['White', 'Black']).forEach(function (c) {
        var hex = (c === 'Black') ? '#1a1a1a' : '#fafaf6';
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'pfc-moulding__mount-btn'; b.dataset.colour = c;
        b.innerHTML = '<span class="pfc-moulding__mount-chip" style="background:' + hex + ';border:1px solid #d9d2c0;"></span>' +
                      '<span class="pfc-moulding__mount-label">' + c + '</span>' +
                      '<span class="pfc-moulding__mount-price"></span>';
        b.addEventListener('click', function () {
          state.addon.colour = c; state.addon.pattern = null; state.addon.patternLabel = null;
          setTierFromState(); applyTierUI(); syncMountOptUI(); syncPersUI(); refreshAddons(); renderPreview();
        });
        elMountColours.appendChild(b);
      });
      (ADD.mountPatterns || []).forEach(function (pp) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'pfc-moulding__mount-btn'; b.dataset.pattern = pp.key;
        b.innerHTML = '<span class="pfc-moulding__mount-chip" style="background:' + patternChipGradientP(pp) + ';border:1px solid #d9d2c0;"></span>' +
                      '<span class="pfc-moulding__mount-label">' + pp.label + '</span>' +
                      '<span class="pfc-moulding__mount-price"></span>';
        b.addEventListener('click', function () {
          state.addon.pattern = pp.key; state.addon.patternLabel = pp.label;
          setTierFromState(); applyTierUI(); syncMountOptUI(); syncPersUI(); refreshAddons(); renderPreview();
        });
        elMountColours.appendChild(b);
      });
    }
    if (elMountStripes) {
      elMountStripes.innerHTML = '';
      var cols = ADD.mountStripeColours || [];
      if (!cols.length && elMountStripeWrap) elMountStripeWrap.dataset.empty = 'true';
      cols.forEach(function (sc) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'pfc-print__chip-btn pfc-print__chip-btn--swatch';
        b.dataset.stripe = sc.hex; b.title = sc.label; b.setAttribute('aria-label', sc.label);
        b.style.setProperty('--sw', sc.hex);
        b.addEventListener('click', function () {
          state.addon.stripeHex = sc.hex; state.addon.stripeLabel = sc.label;
          refreshPatternChips(); syncMountOptUI(); refreshAddons(); renderPreview();
        });
        elMountStripes.appendChild(b);
      });
    }
    // Mount border presets + custom mm.
    if (elMountBorders) {
      elMountBorders.innerHTML = '';
      MOUNT_BORDER_STEPS.forEach(function (mm) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'pfc-print__chip-btn'; b.dataset.border = String(mm);
        b.textContent = fmtDimDisp(mm);
        b.addEventListener('click', function () {
          state.addon.borderMm = mm;
          if (elMountBorderCustom) elMountBorderCustom.value = '';
          syncBorderUI(); refreshAddons(); renderPreview();
        });
        elMountBorders.appendChild(b);
      });
    }
    if (elMountBorderCustom) {
      elMountBorderCustom.addEventListener('input', function () {
        var v = parseInt(elMountBorderCustom.value, 10);
        if (!isFinite(v)) return;
        state.addon.borderMm = Math.max(MOUNT_BORDER_MIN, Math.min(MOUNT_BORDER_MAX, v));
        syncBorderUI(); refreshAddons(); renderPreview();
      });
    }
    // Toggles
    if (elFrameToggle) elFrameToggle.addEventListener('change', function () {
      state.addon.frameOn = elFrameToggle.checked;
      if (state.addon.frameOn && !state.addon.frameCode && ADD.frames[0]) state.addon.frameCode = ADD.frames[0].code;
      if (elFramePicker) elFramePicker.hidden = !state.addon.frameOn;
      syncFrameUI(); syncFraming(); refreshAddons(); renderPreview();
    });
    elFrameFramingBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (!frameIsDeep()) return;
        state.addon.framing = b.dataset.framing;
        syncFraming(); refreshAddons(); renderPreview();
      });
    });
    if (elMountToggle) elMountToggle.addEventListener('change', function () {
      state.addon.mountOn = elMountToggle.checked;
      if (elMountPicker) elMountPicker.hidden = !state.addon.mountOn;
      applyTierUI(); syncMountOptUI(); syncPersUI(); refreshAddons(); renderPreview();
    });
    // Initial defaults: plain White board (standard). A pattern is only set when
    // the customer picks one; keep a default band colour ready for that moment.
    state.addon.pattern = null; state.addon.patternLabel = null;
    if ((ADD.mountStripeColours || [])[0]) { state.addon.stripeHex = ADD.mountStripeColours[0].hex; state.addon.stripeLabel = ADD.mountStripeColours[0].label; }
    if (Number(cfg.defaultBorderMm)) state.addon.borderMm = Number(cfg.defaultBorderMm);
    setTierFromState(); applyTierUI(); syncMountOptUI(); syncBorderUI();
    wirePers();
  }
  // Personalisation panel only applies when a mount is on.
  function syncPersUI() {
    if (elPersWrap) elPersWrap.hidden = !(state.addon.mountOn && persAvailable());
    if (elPersPanel) elPersPanel.hidden = !state.pers.on;
    if (elPersToggle) elPersToggle.checked = state.pers.on;
    updatePersFit();   // border slider can take the band below the printable minimum
    updateLogoFieldsP();
    updatePersPriceP();
  }
  function wirePers() {
    if (!persAvailable() || !elPersToggle) return;
    state.pers.font = (PERS_FONTS[0] || state.pers.font);
    renderPersFontsP();
    elPersAlignBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.persAlign === state.pers.align ? 'true' : 'false'); });
    elPersToggle.addEventListener('change', function () {
      state.pers.on = elPersToggle.checked;
      // Printed text/logo = Premium price (Decision A): re-derive the tier.
      setTierFromState(); applyTierUI(); syncMountOptUI();
      syncPersSizeSteps(0, 0, 1);
      syncPersUI(); refreshAddons(); renderPreview();
    });
    if (PF && elPersPanel) {
      persFit = PF.controller({
        state: function () { return state.pers; },
        zoneMm: persZoneMm,
        familyCss: fontFamilyCssP,
        sizeBtns: elPersSizeBtns, sizeNote: elPersSizeNote,
        heading: elPersHeading, line2: elPersLine2,
        rerender: function () { renderPreview(); }
      });
    }
    if (elPersHeading) elPersHeading.addEventListener('input', function () { state.pers.heading = elPersHeading.value; updatePersPriceP(); refreshAddons(); renderPreview(); });
    if (elPersLine2) elPersLine2.addEventListener('input', function () { state.pers.line2 = elPersLine2.value; updatePersPriceP(); refreshAddons(); renderPreview(); });
    if (elPersFontTrigger) elPersFontTrigger.addEventListener('click', function () { setPersFontOpenP(elPersFontList && elPersFontList.hidden); });
    document.addEventListener('click', function (e) { if (elPersFontSelect && !elPersFontSelect.contains(e.target)) setPersFontOpenP(false); });
    elPersAlignBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        state.pers.align = b.dataset.persAlign;
        elPersAlignBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        renderPreview();
      });
    });
    elPersSizeBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.persSize === state.pers.size ? 'true' : 'false'); });
    elPersSizeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        state.pers.size = b.dataset.persSize;
        elPersSizeBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        renderPreview();
      });
    });
    if (elPersLogoToggle) elPersLogoToggle.addEventListener('change', function () {
      state.pers.logoOn = elPersLogoToggle.checked; updateLogoFieldsP(); updatePersPriceP(); refreshAddons(); renderPreview();
    });
    elPersLogoPosBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        state.pers.logoPos = b.dataset.persLogoPos;
        elPersLogoPosBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        renderPreview();
      });
    });
    if (elPersLogoDrop && elPersLogoInput) {
      elPersLogoDrop.addEventListener('click', function () { elPersLogoInput.click(); });
      elPersLogoInput.addEventListener('change', function (e) { loadPersLogoFileP(e.target.files && e.target.files[0]); });
    }
  }
  // Tier is derived, not chosen: premium when a pattern is picked OR printed
  // text/logo is on (Decision A). All pricing reads state.addon.tier.
  function setTierFromState() {
    state.addon.tier = (state.addon.pattern || state.pers.on) ? 'premium' : 'standard';
  }
  // Single board grid is always shown. The band-colour (pattern colour) picker
  // appears only once a pattern is selected.
  function applyTierUI() {
    if (elMountColourWrap) elMountColourWrap.hidden = false;
    var showStripes = !!state.addon.pattern && !!((ADD && ADD.mountStripeColours) || []).length;
    if (elMountStripeWrap) elMountStripeWrap.hidden = !showStripes;
  }
  function selectFrame(code) {
    state.addon.frameCode = code;
    if (!state.addon.frameOn && elFrameToggle) { elFrameToggle.checked = true; state.addon.frameOn = true; if (elFramePicker) elFramePicker.hidden = false; }
    syncFrameUI(); syncFraming(); refreshAddons(); renderPreview();
  }
  // Hide frame swatches with no variant at the current size; re-point an
  // invalid selection so a frame is never priced at £0.
  function syncFrameAvailability(suf) {
    if (!elFrameGrid) return;
    // Custom size: every frame is bespoke-priced from its own model, so all are
    // available — show the full grid and keep the current selection.
    if (isCustomActive()) {
      Array.from(elFrameGrid.querySelectorAll('[data-frame-code]')).forEach(function (b) { b.hidden = false; });
      if (!state.addon.frameCode && ADD && ADD.frames[0]) { state.addon.frameCode = ADD.frames[0].code; syncFrameUI(); }
      return;
    }
    var firstValid = null;
    Array.from(elFrameGrid.querySelectorAll('[data-frame-code]')).forEach(function (b) {
      var f = frameByCode(b.dataset.frameCode);
      var ok = !!(f && f.sizes && f.sizes[suf]);
      b.hidden = !ok;
      if (ok && !firstValid) firstValid = b.dataset.frameCode;
    });
    var cur = frameByCode(state.addon.frameCode);
    if ((!cur || !cur.sizes || !cur.sizes[suf]) && firstValid) {
      state.addon.frameCode = firstValid; syncFrameUI();
    }
  }
  function syncFrameUI() {
    if (!elFrameGrid) return;
    Array.from(elFrameGrid.querySelectorAll('[data-frame-code]')).forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.frameCode === state.addon.frameCode ? 'true' : 'false');
    });
  }
  function syncMountOptUI() {
    if (elMountColours) Array.from(elMountColours.children).forEach(function (b) {
      var on;
      if (b.dataset.pattern != null) on = (state.addon.pattern === b.dataset.pattern);
      else on = (!state.addon.pattern && b.dataset.colour === state.addon.colour);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (elMountStripes) Array.from(elMountStripes.children).forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.stripe === state.addon.stripeHex ? 'true' : 'false');
    });
    updateMountOptPricesP();
  }

  /* ----- Refresh add-on visibility + stacked price ----- */
  function refreshAddons() {
    if (!addonsEnabled()) return;
    syncPersUI();
    // Show the block on any framable OR mount-up size; hide on custom/tiny-only.
    var capable = addonCapable();
    elAddons.hidden = !capable;
    if (!capable) {
      state.addonBucket = null;
      return;
    }
    var custom = isCustomActive();
    var suf = currentSuffix();
    var mu = needsMountToFrame();
    // Mount-up sizes: a frame is only offered once a mount is chosen (you can't
    // frame a bare print this small). Gate the frame toggle behind the mount.
    if (mu && !state.addon.mountOn && state.addon.frameOn) {
      state.addon.frameOn = false;
      if (elFrameToggle) elFrameToggle.checked = false;
      if (elFramePicker) elFramePicker.hidden = true;
    }
    if (elFrameLabel) elFrameLabel.hidden = mu && !state.addon.mountOn;
    // Mount-up sizes gate the frame behind the mount. Re-order so the frame
    // appears BELOW the mount the customer is configuring (not shoved in above
    // it), and badge it so it's clear why it just appeared.
    if (elAddons) elAddons.dataset.frameGated = mu ? '1' : '';
    if (elFrameUnlock) elFrameUnlock.hidden = !(mu && state.addon.mountOn);
    syncFrameAvailability(suf);
    syncFraming();
    syncBorderUI();
    // Per-toggle price hints.
    if (elFramePrice) {
      var fc = framePriceCentsPreview();
      elFramePrice.textContent = fc ? ('+ ' + formatMoney(fc)) : '';
    }
    if (elMountPrice) {
      var mc = mountPriceCentsPreview();
      elMountPrice.textContent = mc ? ('+ ' + formatMoney(mc)) : '';
    }
    updateMountOptPricesP();   // per-swatch +/- uplift relative to selection
    if (!addonActive()) {
      // Add-ons present but none ticked → plain print price (preset, or the
      // custom size's own bucket — not the last frame/mount total).
      state.addonBucket = null;
      if (elPrice && !isCustomActive()) elPrice.textContent = formatMoney(Number(state.variant.price));
      else if (elPrice && state.customBucket) elPrice.textContent = formatMoney(Math.round((customBaseMajor() + bucketUpchargeMajor(state.customBucket)) * 100));
      if (elAddonNote) {
        if (mu) {
          elAddonNote.hidden = false;
          elAddonNote.textContent = 'Too small to frame on its own — add a mount to frame this size (mounts into a larger frame).';
        } else {
          elAddonNote.hidden = true;
        }
      }
      syncSheet();
      return;
    }
    // A small custom print's mount must take the finished piece to the minimum.
    if (custom && state.addon.frameOn) {
      var outer = addonOuterMm();
      if (Math.min(outer.w, outer.h) < FRAME_MIN_MM) {
        state.addonBucket = null;
        if (elPrice) elPrice.textContent = '—';
        if (elAddonNote) {
          elAddonNote.hidden = false;
          elAddonNote.textContent = 'Too small to frame — widen the mount border so the finished piece is at least '
            + fmtSide(FRAME_MIN_MM) + ' on its shorter side.';
        }
        syncSheet();
        return;
      }
    }
    // Stacked total → match a print ladder bucket (round up). For a custom size
    // the print component is its area price, not the placeholder variant price.
    var printC = custom ? Math.round(customRawPrice(state.customW, state.customH) * 100) : Number(state.variant.price);
    var stacked = (printC + framePriceCents() + mountPriceCents()) / 100;
    var bucket = matchBucket(stacked);
    if (!bucket) {
      state.addonBucket = null;
      if (elPrice) elPrice.textContent = '—';
      if (elAddonNote) { elAddonNote.hidden = false; elAddonNote.textContent = 'This combination is unavailable online — please contact us.'; }
      syncSheet();
      return;
    }
    state.addonBucket = { id: bucket.id, price: bucket.price, name: bucket.name };
    if (elPrice) elPrice.textContent = formatMoney(Math.round((customBaseMajor() + bucketUpchargeMajor(bucket)) * 100));
    if (elCompare) elCompare.style.display = 'none';
    if (elAddonNote) {
      elAddonNote.hidden = false;
      var bits = ['Print'];
      if (state.addon.frameOn) bits.push('frame');
      if (state.addon.mountOn) bits.push('mount');
      elAddonNote.textContent = bits.join(' + ') + ' — one finished piece, single price'
        + (custom ? ', made to your exact size.' : '.');
    }
    syncSheet();
  }
  // Price previews show even before the toggle (so the "+ £x" hint is live).
  function framePriceCentsPreview() {
    if (!state.addon.frameCode && ADD && ADD.frames[0]) state.addon.frameCode = ADD.frames[0].code;
    return frameCentsCore(frameByCode(state.addon.frameCode) || (ADD && ADD.frames[0]));
  }
  function mountPriceCentsPreview() {
    return mountCentsCore();
  }

  /* ---------- Wiring ---------- */
  function setSizeUnit(unit) {
    if (unit !== 'cm' && unit !== 'in') return;
    state.sizeUnit = unit;
    elSizeUnitBtns.forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.sizeUnit === unit ? 'true' : 'false');
    });
    renderSizeList();
    // Keep the selected size in the chosen unit (unless on a custom size).
    if (!isCustomActive() && variantUnit(state.variant) !== unit) {
      var first = cfg.variants.find(function (v) { return !v.isCustom && variantUnit(v) === unit; });
      if (first) selectVariant(first);
    }
    // Re-label every dimension readout in the new unit.
    if (elMountBorders) Array.from(elMountBorders.children).forEach(function (b) {
      if (b.dataset.border) b.textContent = fmtDimDisp(Number(b.dataset.border));
    });
    if (typeof updateSizeChip === 'function') updateSizeChip();
    if (typeof refreshAddons === 'function') refreshAddons();
    syncSheet();
  }
  elSizeUnitBtns.forEach(function (b) {
    b.addEventListener('click', function () { setSizeUnit(b.dataset.sizeUnit); });
    b.setAttribute('aria-pressed', b.dataset.sizeUnit === state.sizeUnit ? 'true' : 'false');
  });
  if (elSizeTrigger) {
    elSizeTrigger.addEventListener('click', function () { setSizeOpen(elSizeList.hidden); });
    document.addEventListener('click', function (e) {
      if (elSizeSelect && !elSizeSelect.contains(e.target)) setSizeOpen(false);
    });
  }
  // Orientation state + its toggle buttons. No re-render: callers do that.
  function setOrientation(o) {
    state.orientation = o;
    elOrientBtns.forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.orientationBtn === o ? 'true' : 'false'); });
  }
  elOrientBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      setOrientation(b.dataset.orientationBtn);
      // Custom size: keep the typed Width/Height agreeing with the toggle, or the
      // next keystroke in either box would flip the orientation straight back.
      if (isCustomActive() && elCustomW && elCustomH) {
        var cw = parseFloat(elCustomW.value), ch = parseFloat(elCustomH.value);
        if (cw && ch && cw !== ch && (cw > ch) !== (state.orientation === 'landscape')) {
          var t = elCustomW.value; elCustomW.value = elCustomH.value; elCustomH.value = t;
          recomputeCustom();
        }
      }
      updateSizeChip(); applyPreviewAspect(); renderPreview();
      renderSizeList();
      if (elSizeValue && state.variant && !state.variant.isCustom) elSizeValue.textContent = orientedTitle(state.variant.title);
    });
  });
  if (elUpload) {
    elUpload.addEventListener('click', function (e) {
      if (e.target.closest('[data-upload-actions]')) return;
      if (elUpload.dataset.hasImage === 'true') { reopenCropper(); return; }
      elFileInput && elFileInput.click();
    });
  }
  if (elFileInput) {
    elFileInput.addEventListener('change', function () {
      var f = elFileInput.files && elFileInput.files[0];
      if (f) openCropper(f);
      elFileInput.value = '';
    });
  }
  if (elRecrop) elRecrop.addEventListener('click', function (e) { e.stopPropagation(); reopenCropper(); });
  if (elReplace) elReplace.addEventListener('click', function (e) { e.stopPropagation(); elFileInput && elFileInput.click(); });
  if (elCropCancel) elCropCancel.addEventListener('click', cancelCrop);
  if (elCropConfirm) elCropConfirm.addEventListener('click', confirmCrop);
  if (elAtc) elAtc.addEventListener('click', addToCart);

  if (elCustomW) elCustomW.addEventListener('input', recomputeCustom);
  if (elCustomH) elCustomH.addEventListener('input', recomputeCustom);
  elCustomUnitBtns.forEach(function (b) {
    b.setAttribute('aria-pressed', b.dataset.customUnit === state.customUnit ? 'true' : 'false');
    b.addEventListener('click', function () {
      var newUnit = b.dataset.customUnit;
      if (newUnit === state.customUnit) return;
      [elCustomW, elCustomH].forEach(function (inp) {
        if (!inp || !inp.value) return;
        var n = parseFloat(inp.value); if (!n) return;
        inp.value = newUnit === 'in' ? Number((n / 2.54).toFixed(2)) : Number((n * 2.54).toFixed(1));
      });
      state.customUnit = newUnit;
      elCustomUnitBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      recomputeCustom();
    });
  });
  // Keep an element visually fixed across a layout change (toggling custom size
  // hides the add-on block + reveals the custom inputs, which otherwise shifts
  // the page under the user). Restores scroll so the anchor stays put.
  function scrollParentOf(el) {
    for (var n = el && el.parentElement; n; n = n.parentElement) {
      var s = getComputedStyle(n);
      if (/(auto|scroll)/.test(s.overflowY) && n.scrollHeight > n.clientHeight) return n;
    }
    return window;
  }
  function preserveAnchor(anchor, fn) {
    if (!anchor) { fn(); return; }
    var sc = scrollParentOf(anchor);
    var before = anchor.getBoundingClientRect().top;
    fn();
    requestAnimationFrame(function () {
      var d = anchor.getBoundingClientRect().top - before;
      if (Math.abs(d) < 1) return;
      if (sc === window) window.scrollBy(0, d); else sc.scrollTop += d;
    });
  }
  if (elCustomToggle) {
    elCustomToggle.addEventListener('change', function () {
      var anchor = elCustomToggle.closest('details') || elCustomToggle;
      preserveAnchor(anchor, function () {
        var cv = customVariant();
        if (elCustomToggle.checked && cv) {
          if (!state.variant.isCustom) state.prevStandardVariant = state.variant;
          if (elCustom) elCustom.hidden = false;
          selectVariant(cv);
        } else {
          if (elCustom) elCustom.hidden = true;
          var back = state.prevStandardVariant || cfg.variants.find(function (v) { return !v.isCustom; });
          if (back) selectVariant(back);
        }
      });
    });
  }

  var resizeRaf = null;
  window.addEventListener('resize', function () {
    if (resizeRaf) cancelAnimationFrame(resizeRaf);
    resizeRaf = requestAnimationFrame(renderPreview);
  });

  /* ---------- Query-string presets (size / orientation) ---------- */
  function applyQueryPresets() {
    var qs;
    try { qs = new URLSearchParams(window.location.search); } catch (_) { return; }
    var qSize = (qs.get('size') || '').trim();
    var qOrient = (qs.get('orientation') || '').toLowerCase();
    if (qOrient === 'landscape' || qOrient === 'portrait') state.orientation = qOrient;
    if (qSize) {
      var norm = qSize.toLowerCase().replace(/\s+/g, '');
      if (norm === 'custom' || norm === 'customsize') {
        var cv = customVariant(); if (cv) { state.variant = cv; if (elCustomToggle) elCustomToggle.checked = true; if (elCustom) elCustom.hidden = false; }
      } else {
        var m = cfg.variants.find(function (v) { return !v.isCustom && v.title.toLowerCase().replace(/\s+/g, '') === norm; });
        if (m) state.variant = m;
      }
    }
  }

  /* ---------- Mobile bottom-sheet (ported from pfc-moulding.js) ---------- */
  (function initSheet() {
    if (!elSheet || !elSheetHandle) return;
    var MOBILE_BP = 920, DRAG_THRESHOLD = 6, FLICK_VELOCITY = 0.6;
    var s = { mode: 'peek', dragging: false, pointerId: null, startY: 0, lastY: 0, lastT: 0, velocity: 0, moved: false, sheetH: 0, peekH: 0 };
    function measure() {
      s.sheetH = elSheet.offsetHeight || (window.innerHeight * 0.88);
      s.peekH = elSheetHandle.offsetHeight || Math.round(window.innerHeight * 0.08);
      document.documentElement.style.setProperty('--peek-h', s.peekH + 'px');
    }
    function setBodyState() {
      document.body.setAttribute('data-sheet-state', s.mode);
      elSheetHandle.setAttribute('aria-expanded', s.mode === 'full' ? 'true' : 'false');
    }
    function setMode(mode) { s.mode = mode === 'full' ? 'full' : 'peek'; elSheet.style.transform = ''; setBodyState(); applyScrolledPast(); }
    function isMobile() { return window.innerWidth <= MOBILE_BP; }
    function activate() {
      if (document.body.getAttribute('data-sheet-active') === 'true') return;
      document.body.setAttribute('data-sheet-active', 'true'); measure(); setBodyState();
    }
    function deactivate() {
      if (s.dragging) return;
      if (document.body.getAttribute('data-sheet-active') !== 'true') return;
      document.body.removeAttribute('data-sheet-active');
      document.body.removeAttribute('data-sheet-state');
      document.body.removeAttribute('data-sheet-dragging');
      document.body.removeAttribute('data-sheet-scrolled-past');
      elSheet.style.transform = '';
    }
    var sentinel = root.querySelector('[data-preview]') || elCanvas || root;
    var previewVisible = true, rafQueued = false;
    function applyScrolledPast() {
      var condense = !previewVisible && s.mode === 'peek';
      if (condense) document.body.setAttribute('data-sheet-scrolled-past', 'true');
      else document.body.removeAttribute('data-sheet-scrolled-past');
      requestAnimationFrame(measure);
    }
    function checkInView() {
      rafQueued = false;
      if (!isMobile()) {
        if (document.body.getAttribute('data-sheet-active') === 'true') deactivate();
        document.body.removeAttribute('data-sheet-scrolled-past');
        return;
      }
      if (document.body.getAttribute('data-sheet-active') !== 'true') activate();
      var r = sentinel.getBoundingClientRect();
      var vh = document.documentElement.clientHeight || window.innerHeight;
      var visible = Math.max(0, Math.min(vh, r.bottom) - Math.max(0, r.top));
      if (previewVisible) { if (visible <= 40) { previewVisible = false; applyScrolledPast(); } }
      else { if (visible >= 120) { previewVisible = true; applyScrolledPast(); } }
    }
    function queueCheck() { if (rafQueued) return; rafQueued = true; requestAnimationFrame(checkInView); }
    requestAnimationFrame(function () { requestAnimationFrame(queueCheck); });
    window.addEventListener('load', queueCheck);
    window.addEventListener('scroll', queueCheck, { passive: true });
    var resizeT = 0;
    window.addEventListener('resize', function () { clearTimeout(resizeT); resizeT = setTimeout(queueCheck, 120); });

    elSheetHandle.addEventListener('pointerdown', function (e) {
      if (!isMobile()) return;
      s.dragging = true; s.moved = false; s.pointerId = e.pointerId;
      s.startY = e.clientY; s.lastY = e.clientY; s.lastT = performance.now(); s.velocity = 0;
      measure();
      try { elSheetHandle.setPointerCapture(e.pointerId); } catch (_) {}
      document.body.setAttribute('data-sheet-dragging', 'true');
    });
    elSheetHandle.addEventListener('pointermove', function (e) {
      if (!s.dragging || e.pointerId !== s.pointerId) return;
      var dy = e.clientY - s.startY;
      if (Math.abs(dy) > DRAG_THRESHOLD) s.moved = true;
      var origin = s.mode === 'full' ? 0 : (s.sheetH - s.peekH);
      var clamped = Math.max(0, Math.min(s.sheetH - s.peekH, origin + dy));
      elSheet.style.transform = 'translateY(' + clamped + 'px)';
      var now = performance.now(), dt = Math.max(1, now - s.lastT);
      s.velocity = (e.clientY - s.lastY) / dt; s.lastY = e.clientY; s.lastT = now;
    });
    function endDrag(e) {
      if (!s.dragging) return;
      if (e && e.pointerId !== s.pointerId) return;
      s.dragging = false;
      document.body.removeAttribute('data-sheet-dragging');
      try { elSheetHandle.releasePointerCapture(s.pointerId); } catch (_) {}
      if (!s.moved) { setMode(s.mode === 'full' ? 'peek' : 'full'); return; }
      if (Math.abs(s.velocity) > FLICK_VELOCITY) { setMode(s.velocity < 0 ? 'full' : 'peek'); return; }
      var m = elSheet.style.transform.match(/translateY\((-?[\d.]+)px\)/);
      var ty = m ? parseFloat(m[1]) : 0;
      setMode(ty < (s.sheetH - s.peekH) / 2 ? 'full' : 'peek');
    }
    elSheetHandle.addEventListener('pointerup', endDrag);
    elSheetHandle.addEventListener('pointercancel', endDrag);
    elSheetHandle.addEventListener('keydown', function (e) {
      if (!isMobile()) return;
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setMode(s.mode === 'full' ? 'peek' : 'full'); }
      if (e.key === 'Escape' && s.mode === 'full') { e.preventDefault(); setMode('peek'); }
    });
    setBodyState();
  })();

  /* ---------- Init ---------- */
  applyQueryPresets();
  renderSizeList();
  buildAddons();
  if (persAvailable()) loadPersFontsP();
  selectVariant(state.variant);
  startSamples();
})();

/* cache-bust 1781072758 */

/* deploy: composite preview v2 202606100730 */

